<template>
  <div class="recupero-pagamento-dashboard">
    <Loader v-if="loading" />
    <div class="card" v-if="!selectedSection">
      <div class="card-header">
        <h2>Scegli la tipologia</h2>
      </div>
      <div class="card-body">
        <button
          class="section-btn"
          :class="{ active: selectedSection === 'cliente', shadow: selectedSection === 'cliente' }"
          @click="handleClienteClick()"
        >CLIENTE</button>
        <button
          class="section-btn"
          :class="{ active: selectedSection === 'rappresentante', shadow: selectedSection === 'rappresentante' }"
          @click="handleRappresentanteClick"
        >RAPPRESENTANTE</button>
      </div>
    </div>

    <div v-if="selectedSection">
      <div v-if="!loading && !currentCredito && !error" class="no-credito-message">
        <i class="pi pi-check-circle"></i>
        <h3>Nessun credito da gestire</h3>
        <p>Non ci sono crediti in attesa di gestione al momento.</p>
      </div>
      <div v-else>
        <div class="user-header">
          <div class="header-top-row">
            <div class="user-name-container">
              <div class="name-and-button-container">
                <h1 class="dashboard-title">
                  <span class="cliccabile">
                    {{
                      currentCredito?.ragsoc
                        ? currentCredito.ragsoc
                        : (
                            (currentCredito?.nome || '') +
                            ' ' +
                            (currentCredito?.cognome || '')
                          ).trim()
                    }}
                  </span>
                  <span v-if="sourceLabel" class="source-label"> ({{ sourceLabel }})</span><span v-if="privilegiatoText" class="source-label"> {{ privilegiatoText }}</span>
                </h1>
              </div>
              <h2 class="dashboard-subtitle">
                € {{ selectedSection === 'rappresentante' && rankingSaldo !== null ? formatCurrency(rankingSaldo) : (totaleSaldo !== null ? formatCurrency(totaleSaldo) : '') }}
              </h2>
            </div>
          </div>
        </div>

        <div>
          <div class="dashboard-boxes-row">
            <div class="dashboard-box pod-box">
              <div class="box-label">POD</div>
              <div class="box-value">
                {{ dettaglioContatto?.pods_summary?.count_pods_attivi ?? '-' }} su {{ dettaglioContatto?.pods_summary?.count_totale_pod ?? '-' }}
              </div>
            </div>
            <div class="dashboard-box insoluto-pod-box">
              <div class="box-label">Insoluto POD</div>
              <div class="box-value">
                € {{ dettaglioContatto?.pods_summary ? formatCurrency(Number(dettaglioContatto.pods_summary.somma_saldo_pods) || 0) : '0,00' }} su {{ dettaglioContatto?.pods_summary ? formatCurrency(Number(dettaglioContatto.pods_summary.somma_totale_fatturato_pods) || 0) : '0,00' }}
              </div>
            </div>
            <div class="dashboard-box pdr-box">
              <div class="box-label">PDR</div>
              <div class="box-value">
                {{ dettaglioContatto?.pods_summary?.count_pdr_attivi ?? '-' }} su {{ dettaglioContatto?.pods_summary?.count_totale_pdr ?? '-' }}
              </div>
            </div>
            <div class="dashboard-box insoluto-pdr-box">
              <div class="box-label">Insoluto PDR</div>
              <div class="box-value">
                € {{ dettaglioContatto?.pods_summary ? formatCurrency(Number(dettaglioContatto.pods_summary.somma_saldo_pdr) || 0) : '0,00' }} su {{ dettaglioContatto?.pods_summary ? formatCurrency(Number(dettaglioContatto.pods_summary.somma_totale_fatturato_pdr) || 0) : '0,00' }}
              </div>
            </div>
            <div class="dashboard-box">
              <div class="box-label">Numero Clienti</div>
              <div class="box-value">
                <div v-if="selectedSection === 'rappresentante'">
                  {{ dettaglioContatto?.totale_clienti_tipo_3 || 0 }} su {{ dettaglioContatto?.totale_clienti || 0 }}
                </div>
                <div v-else>
                  {{ dettaglioContatto?.totale_clienti || 1 }}
                </div>
              </div>
            </div>
            <div class="dashboard-box">
                  <div class="box-label">Agente</div>
                  <div class="box-value">
                     {{ dettaglioContatto?.agente?.name || dettaglioContatto?.agente?.agente_name || 'Non disponibile' }} 
                  </div>
                </div>
          </div>

        </div>

        <div v-if="selectedSection === 'rappresentante'">
          <div v-if="clientiConSaldo.length > 0" class="clienti-boxes">
            <div 
              v-for="(cliente, index) in clientiConSaldo" 
              :key="index" 
              class="cliente-box"
            >
              <div class="cliente-nome">{{ cliente.nome }}</div>
              <div class="cliente-saldo">€ {{ formatCurrency(cliente.saldo) }}</div>
            </div>
          </div>
          <div v-else class="no-clienti-message">
            <p>Nessun cliente con saldo disponibile</p>
          </div>
        </div>
        

        <div v-if="error" class="error-message">
          <i class="pi pi-exclamation-triangle"></i>
          {{ error }}
        </div>

        <div class="main-content">
          <div class="user-details-card">
            <div class="info-card-header">
              <div class="header-content">
                <h3 class="section-title">Dettagli Utente</h3>
                <button 
                  class="incall-navigation-btn" 
                  @click="navigateToIncall"
                  :title="`Vai alla pagina Incall per ${selectedSection === 'rappresentante' ? 'questo rappresentante' : 'questo cliente'}`"
                >
                  <span>INCALL</span>
                </button>
              </div>
            </div>
            <div class="info-card-content" v-if="dettaglioContatto">
              <template v-if="selectedSection === 'rappresentante' && dettaglioContatto.rappresentante">
                <div class="info-row">
                  <span class="info-label">Telefono:</span>
                  <span class="info-value telefono-grande">
                    {{ getTelefonoValido(dettaglioContatto) }}
                  </span>
                </div>
                <div class="info-row">
                  <span class="info-label">Email:</span>
                  <span class="info-value">
                    {{ dettaglioContatto.rappresentante.email || 'Non disponibile' }}
                  </span>
                </div>
                <div class="info-row">
                  <span class="info-label">PEC:</span>
                  <span class="info-value">
                    {{ dettaglioContatto.rappresentante.pec || 'Non disponibile' }}
                  </span>
                </div>
                <div class="info-row">
                  <span class="info-label">Via:</span>
                  <span class="info-value">Non disponibile</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Città:</span>
                  <span class="info-value">Non disponibile</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Codice Fiscale:</span>
                  <span class="info-value">
                    {{ dettaglioContatto.rappresentante.codfis || 'Non disponibile' }}
                  </span>
                </div>
                <div class="info-row">
                  <span class="info-label">PDP:</span>
                  <span class="info-value">Non disponibile</span>
                </div>
              </template>
              <template v-else>
                <div class="info-row">
                  <span class="info-label">Telefono:</span>
                  <span class="info-value telefono-grande">
                    {{ getTelefonoValido(dettaglioContatto) }}
                  </span>
                </div>
                <div class="info-row">
                  <span class="info-label">Email:</span>
                  <span class="info-value">{{ getEmailValida(dettaglioContatto) }}</span>   
                </div>
                <div class="info-row">
                  <span class="info-label">Via:</span>
                  <span class="info-value">{{ dettaglioContatto.contatto.indirizzo_completo_cliente || 'Non disponibile' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Città:</span>
                  <span class="info-value">{{ dettaglioContatto.contatto.comune_name || 'Non disponibile' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Codice Fiscale:</span>
                  <span class="info-value">{{ dettaglioContatto.contatto.codfis || 'Non disponibile' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">PDP:</span>
                  <span class="info-value pdp-cliccabile" @click="navigateToPdpDetail(currentCredito.cod_pod, currentCredito.cod_pdr)">{{ currentCredito.code || 'Non disponibile' }}</span>
                </div>
              </template>
              
              <template v-if="dettaglioContatto && dettaglioContatto.fatture_stats">
                <div class="stats-divider"></div>
                <div class="info-row stats-header">
                  <span class="stats-title">Statistiche Fatture</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Tot. Fatturato:</span>
                  <span class="info-value stats-value">
                    {{ formatCurrency(dettaglioContatto.fatture_stats.euro_fatturati) }}
                  </span>
                </div>
                <div class="info-row">
                  <span class="info-label">Tot. Pagato:</span>
                  <span class="info-value stats-value">
                    {{ formatCurrency(dettaglioContatto.fatture_stats.euro_pagati) }}
                  </span>
                </div>
                <div class="info-row">
                  <span class="info-label">Saldo:</span>
                  <span class="info-value stats-value" :class="getSaldoClass(dettaglioContatto.fatture_stats.saldo_residuo)">
                    {{ formatCurrency(dettaglioContatto.fatture_stats.saldo_residuo) }}
                  </span>
                </div>
                <div class="info-row" v-if="dettaglioContatto.fatture_stats.saldo_per_fornitura.saldo_pod !== undefined">
                  <span class="info-label">Saldo POD (Energia Elettrica):</span>
                  <span class="info-value stats-value" :class="getSaldoClass(dettaglioContatto.fatture_stats.saldo_per_fornitura.saldo_pod)">
                    {{ formatCurrency(dettaglioContatto.fatture_stats.saldo_per_fornitura.saldo_pod) }}
                  </span>
                </div>
                <div class="info-row" v-if="dettaglioContatto.fatture_stats.saldo_per_fornitura.saldo_pdr !== undefined">
                  <span class="info-label">Saldo PDR (Gas):</span>
                  <span class="info-value stats-value" :class="getSaldoClass(dettaglioContatto.fatture_stats.saldo_per_fornitura.saldo_pdr)">
                    {{ formatCurrency(dettaglioContatto.fatture_stats.saldo_per_fornitura.saldo_pdr) }}
                  </span>
                </div>
              </template>
            </div>
          </div>

          <div class="ft-insolute-container">
            <div class="fatture-table-header">
              <h3 class="section-title">
                FATTURE INSOLUTE
                <span class="sospendibile-legend">
                  <span class="legend-square"></span>
                  appartenenza lista comuni calamità naturali
                </span>
              </h3>
              <div class="table-actions" v-if="notificaPreavvisi === '0'">
                <button 
                  class="add-ticket-btn send-bonaria-btn" 
                  @click="openEmailBonariaDialog"
                  :disabled="!fattureTabella || fattureTabella.length === 0"
                >
                  <i class=""></i>
                  Invia Email Bonaria
                </button>
              </div>
            </div>
            
            <div class="fatture-table-wrapper">
              <table class="fatture-table">
                <thead>
                  <tr>
                    <th @click="sortBy('code')" style="cursor:pointer">
                      PDP <span v-if="sortKey === 'code'">{{ sortAsc ? '▲' : '▼' }}</span>
                    </th>
                    <th @click="sortBy('ragsoc')" style="cursor:pointer">
                      Ragione Sociale <span v-if="sortKey === 'ragsoc'">{{ sortAsc ? '▲' : '▼' }}</span>
                    </th>
                    <th @click="sortBy('code_cliente')" style="cursor:pointer">
                      Codice Cliente <span v-if="sortKey === 'code_cliente'">{{ sortAsc ? '▲' : '▼' }}</span>
                    </th>
                    <th @click="sortBy('indirizzo_cliente_completo')" style="cursor:pointer">
                      Indirizzo <span v-if="sortKey === 'indirizzo_cliente_completo'">{{ sortAsc ? '▲' : '▼' }}</span>
                    </th>
                    <th @click="sortBy('numero')" style="cursor:pointer">
                      Numero <span v-if="sortKey === 'numero'">{{ sortAsc ? '▲' : '▼' }}</span>
                    </th>
                    <th @click="sortBy('data_emissione')" style="cursor:pointer">
                      Emissione <span v-if="sortKey === 'data_emissione'">{{ sortAsc ? '▲' : '▼' }}</span>
                    </th>
                    <th @click="sortBy('data_scadenza_fattura')" style="cursor:pointer">
                      Scadenza <span v-if="sortKey === 'data_scadenza_fattura'">{{ sortAsc ? '▲' : '▼' }}</span>
                    </th>
                    <th @click="sortBy('data_invio_preavviso')" style="cursor:pointer">
                      Data Invio Preavviso
                      <span v-if="sortKey === 'data_invio_preavviso'">{{ sortAsc ? '▲' : '▼' }}</span>
                    </th>
                    <th @click="sortBy('data_scadenza_preavviso')" style="cursor:pointer">
                      Data Scadenza Preavviso
                      <span v-if="sortKey === 'data_scadenza_preavviso'">{{ sortAsc ? '▲' : '▼' }}</span>
                    </th>
                    <th @click="sortBy('totale')" style="cursor:pointer">
                      Totale Fattura <span v-if="sortKey === 'totale'">{{ sortAsc ? '▲' : '▼' }}</span>
                    </th>
                    <th @click="sortBy('saldo_fattura')" style="cursor:pointer">
                      Importo <span v-if="sortKey === 'saldo_fattura'">{{ sortAsc ? '▲' : '▼' }}</span>
                    </th>
                    <th @click="sortBy('type_state_name')" style="cursor:pointer">
                      Stato <span v-if="sortKey === 'type_state_name'">{{ sortAsc ? '▲' : '▼' }}</span>
                    </th>
                    <th @click="sortBy('agente_firmatario_name')" style="cursor:pointer">
                      Agente Firmatario <span v-if="sortKey === 'agente_firmatario_name'">{{ sortAsc ? '▲' : '▼' }}</span>
                    </th>
                    <th @click="sortBy('cmor')" style="cursor:pointer">
                      CMOR <span v-if="sortKey === 'cmor'">{{ sortAsc ? '▲' : '▼' }}</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="fattura in getSortedFatture()"
                    :key="fattura.fattura_id"
                    :class="{
                      'row-nonpositive': Number(fattura.saldo_fattura) <= 0,
                      'row-sospendibile': Number(fattura.ech) === 1
                    }"
                  >
                    <td
                      class="pdp-cliccabile"
                      @click="navigateToPdpDetail(fattura.cod_pod, fattura.cod_pdr)"
                    >
                      {{ fattura.code }}
                    </td>
                    <td class="cliccabile" @click="navigateToClienteDetail(fattura.cliente_id)">
                      {{ (fattura.ragsoc || (fattura.nome + ' ' + fattura.cognome)).trim() }}
                    </td>
                    <td class="cliccabile" @click="navigateToClienteDetail(fattura.cliente_id)">{{ fattura.code_cliente }}</td>
                    <td>{{ fattura.indirizzo_cliente_completo }}</td>
                    <td>
                      <span class="fattura-cliccabile" @click="navigateToFatturaDetail(fattura.numero)">
                        {{ fattura.numero }}
                      </span>
                    </td>
                    <td>{{ formatDate(fattura.data_emissione) }}</td>
                    <td>{{ formatDate(fattura.data_scadenza_fattura) }}</td>
                    <td>{{ formatDate(fattura.data_invio_preavviso) }}</td>
                    <td>{{ formatDate(fattura.data_scadenza_preavviso) }}</td>
                    <td class="importo-cell">€ {{ formatCurrency(fattura.totale) }}</td>
                    <td class="importo-cell">€ {{ formatCurrency(fattura.saldo_fattura) }}</td>
                    <td class="text-center">
                      <span class="status-dot stato-default"></span>
                      <span class="status-text"> {{ fattura.type_state_name }}</span>
                    </td>
                    <td>{{ fattura.agente_firmatario_name || '-' }}</td>
                    <td class="text-center">
                      <span 
                        class="status-dot" 
                        :class="fattura.cmor > 0 ? 'cmor-green' : 'cmor-red'"
                      ></span>
                    </td>
                  </tr>
                  <tr v-if="getSortedFatture().length === 0">
                    <td colspan="14" class="no-data-message">
                      Nessuna fattura insoluta disponibile
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="pagination-container" v-if="totalPagesFatture > 1">
              <div class="pagination-info">
                Mostrando {{ startIndexFatture }} - {{ endIndexFatture }} di {{ getSortedFatture().length }} fatture
              </div>
              <div class="pagination-controls">
                <button class="pagination-btn" @click="previousPageFatture" :disabled="currentPageFatture === 1">
                  <i class="pi pi-chevron-left pagination-icon"></i>
                </button>
                <span class="page-indicator">{{ currentPageFatture }} / {{ totalPagesFatture }}</span>
                <button class="pagination-btn" @click="nextPageFatture" :disabled="currentPageFatture === totalPagesFatture">
                  <i class="pi pi-chevron-right pagination-icon"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="tickets-table-container">
          <div class="fatture-table-header">
            <h3 class="section-title">Ticket</h3>
            <div class="table-actions">
              <button class="add-ticket-btn" @click="openAddTicketModal">
                <i class=""></i>
                Nuovo Ticket
              </button>
            </div>
          </div>
          
          <div class="fatture-table-wrapper">
            <table class="fatture-table">
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Autore</th>
                  <th>Data</th>
                  <th>Titolo Nota</th>
                  <th>Contenuto</th>
                  <th v-if="selectedSection === 'rappresentante'">RAPPRESENTANTE</th>
                  <th v-else>Ragione Sociale</th>
                  <th>Stato PDP</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="ticket in uniqueTickets" :key="ticket.id_ticket">
                  <td>{{ ticket.tipo || 'Ticket' }}</td>
                  <td>{{ ticket.creator_name }}</td>
                  <td>{{ formatDate(ticket.data || ticket.datetime) }}</td>
                  <td>{{ ticket.title }}</td>
                  <td>{{ ticket.last_message }}</td>
                  <td v-if="selectedSection === 'rappresentante'">
                    {{ ticket.assigned_rappresentante_name || 'Non disponibile' }}
                  </td>
                  <td v-else>
                    {{
                      clientData?.ragsoc
                        ? clientData.ragsoc
                        : [clientData?.nome, clientData?.cognome].filter(Boolean).join(' ')
                    }}
                  </td>
                  <td>
                    <span class="status-badge" :class="getStatusClass(ticket.status)">
                      {{ ticket.status }}
                    </span>
                  </td>
                </tr>
                <tr v-if="uniqueTickets.length === 0">
                  <td colspan="6" class="no-data-message">
                    {{ searchQuery ? 'Nessun ticket trovato per la ricerca corrente' : 'Nessun ticket disponibile' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="pagination-container" v-if="totalPagesTickets > 1">
            <div class="pagination-info">
              Mostrando {{ startIndexTickets }} - {{ endIndexTickets }} di {{ filteredTickets.length }} ticket
            </div>
            <div class="pagination-controls">
              <button class="pagination-btn" @click="previousPageTickets" :disabled="currentPageTickets === 1">
                <i class="pi pi-chevron-left pagination-icon"></i>
              </button>
              <span class="page-indicator">{{ currentPageTickets }} / {{ totalPagesTickets }}</span>
              <button class="pagination-btn" @click="nextPageTickets" :disabled="currentPageTickets === totalPagesTickets">
                <i class="pi pi-chevron-right pagination-icon"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="notes-table-container">
          <div class="fatture-table-header">
            <h3 class="section-title">Note</h3>
          </div>
          <div class="fatture-table-wrapper">
            <table class="fatture-table">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Messaggio</th>
                </tr>
              </thead>
              <tbody v-if="parsedNotes.length > 0">
                <tr v-for="(n, i) in parsedNotes" :key="i">
                  <td>{{ n.nome }}</td>
                  <td>{{ n.messaggio }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="2" class="no-data-message">Nessuna nota disponibile</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="dilazioni-table-container">
          <div class="fatture-table-header">
            <h3 class="section-title">Dilazioni</h3>
          </div>
          
          <DilazioniAll 
            ref="dilazioniComponentRef"
            :client-ids="clientIds"
            :hide-controls="true"
          />
        </div>

        <div v-if="selectedSection === 'rappresentante'">
          <RiepilogoMensileInsoluti
            ref="riepilogoRef"
            :rappresentante-id="currentCredito?.rappresentante_id"
            :anni="[previousYear, currentYear]"
            :hide-search="true"
          />
        </div>
        <div class="main-action-buttons">
          <button class="main-action-btn dilaziona-btn" @click="handleDilaziona">
            <span>DILAZIONA</span>
          </button>
          <button class="main-action-btn rimanda-btn" @click="handleRimanda">
            <span>RIMANDA</span>
          </button>
          <button
            v-if="isDistaccaAllowed"
            class="main-action-btn distacca-btn"
            @click="handleDistacca"
          >
            <span>DISTACCA</span>
          </button>
          <button class="main-action-btn tutela-btn" @click="handleTutela">
            <span>RILASCIA IN TUTELA</span>
          </button>
        </div>

        <div v-if="showTicketModal" class="modal-overlay" @click="closeModal">
          <div class="modal-content" @click.stop>
            <div class="modal-header modal-header-view">
              <h3>Dettagli Ticket</h3>
              <button class="close-button" @click="closeModal">×</button>
            </div>
            <div class="modal-body">
              <div class="ticket-details">
                <div class="detail-row">
                  <strong>Tipo:</strong> {{ selectedTicket.tipo }}
                </div>
                <div class="detail-row">
                  <strong>Autore:</strong> {{ selectedTicket.autore }}
                </div>
                <div class="detail-row">
                  <strong>Data:</strong> {{ formatDate(selectedTicket.data) }}
                </div>
                <div class="detail-row">
                  <strong>Stato PDP:</strong> {{ selectedTicket.statoPdp }}
                </div>
                <div class="detail-row">
                  <strong>Ragione Sociale:</strong> {{ selectedTicket.ragioneSociale }}
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn-secondary" @click="closeModal">Chiudi</button>
            </div>
          </div>
        </div>

        <div v-if="showRimandaModal" class="modal-overlay" @click="closeRimandaModal">
          <div class="modal-content" @click.stop>
            <div class="modal-header">
              <h3>Rimanda Recupero</h3>
              <button class="close-button" @click="closeRimandaModal">×</button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label for="rimanda-note">Note:</label>
                <textarea 
                  id="rimanda-note"
                  v-model="rimandaData.note" 
                  placeholder="Inserisci le note per il rimando..."
                  class="form-textarea"
                  rows="4"
                ></textarea>
              </div>
              <div class="form-group">
                <label for="rimanda-data">Data di Rimando:</label>
                <input 
                  type="date" 
                  id="rimanda-data"
                  v-model="rimandaData.dataRimando"
                  :min="today"
                  :max="maxDate"
                  class="form-input"
                />
                <small class="form-help">Seleziona una data entro i 6 mesi da oggi</small>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn-secondary" @click="closeRimandaModal">Annulla</button>
              <button class="btn-primary" @click="confermaRimanda" :disabled="!rimandaData.note || !rimandaData.dataRimando">
                Conferma Rimando
              </button>
            </div>
          </div>
        </div>

        <div v-if="showDistaccaModal" class="modal-overlay" @click="closeDistaccaModal">
          <div class="modal-content" @click.stop>
            <div class="modal-header">
              <h3>Distacca Recupero</h3>
              <button class="close-button" @click="closeDistaccaModal">×</button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label for="distacca-note">Note Distacco:</label>
                <textarea 
                  id="distacca-note"
                  v-model="distaccaData.note" 
                  placeholder="Inserisci le note per il distacco..."
                  class="form-textarea"
                  rows="4"
                ></textarea>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn-secondary" @click="closeDistaccaModal">Annulla</button>
              <button class="btn-primary" @click="confermaDistacca">
                Conferma Distacco
              </button>
            </div>
          </div>
        </div>

        <div v-if="showDilazioneModal" class="modal-overlay" @click="closeDilazioneModal">
          <div class="modal-content" @click.stop>
            <div class="modal-header">
              <h3>Dilaziona Recupero</h3>
              <button class="close-button" @click="closeDilazioneModal">×</button>
            </div>
            <div class="modal-body">
              <div class="dilazione-question">
                <p>Vuoi procedere con la dilazione del recupero?</p>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn-secondary" @click="closeDilazioneModal">No</button>
              <button class="btn-primary" @click="confermaDilazione">
                Sì, Dilaziona
              </button>
              <button class="btn-success" @click="creaDilazioni">
                Crea Dilazioni
              </button>
            </div>
          </div>
        </div>

        

        <div v-if="showTutelaModal" class="modal-overlay" @click="closeTutelaModal">
          <div class="modal-content" @click.stop>
            <div class="modal-header">
              <h3>Rilascio in Tutela</h3>
              <button class="close-button" @click="closeTutelaModal">×</button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label for="tutela-note">Note Rilascio:</label>
                <textarea 
                  id="tutela-note"
                  v-model="tutelaData.note" 
                  placeholder="Inserisci le note per il rilascio in tutela..."
                  class="form-textarea"
                  rows="4"
                ></textarea>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn-secondary" @click="closeTutelaModal">Annulla</button>
              <button class="btn-primary" @click="confermaTutela" :disabled="!tutelaData.note">
                Conferma Rilascio
              </button>
            </div>
          </div>
        </div>

        <div v-if="showConfermaDilazioneModal" class="modal-overlay" @click="closeConfermaDilazioneModal">
          <div class="modal-content modal-content-medium" @click.stop>
            <div class="modal-header">
              <h3>Conferma Dilazione</h3>
              <button class="close-button" @click="closeConfermaDilazioneModal">×</button>
            </div>
            <div class="modal-body">
              <div class="conferma-dilazione-content">
                <div class="info-section">
                  <h4>Dettagli della dilazione:</h4>
                  <div class="mb-2">
                    <strong>Nota:</strong> {{ dilazioneData.note || 'Nessuna nota' }}
                  </div>
                  <div class="mb-2">
                    <strong>Data rimando: </strong> 
                    <span>{{ formatDateForDisplay(dataRimandaConferma) }}</span>
                  </div>
                </div>
                
                <div class="warning-section">
                  <p>Sei sicuro di voler procedere con questa dilazione?</p>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-secondary" @click="closeConfermaDilazioneModal">
                Annulla
              </button>
              <button class="btn btn-primary" @click="confermaDilazioneFinale">
                Conferma Dilazione
              </button>
            </div>
          </div>
        </div>

        <div v-if="showPodPdrSelectionModal" class="modal-overlay" @click="closePodPdrSelectionModal">
          <div class="modal-content modal-content-large" @click.stop>
            <div class="modal-header">
              <h3>{{ currentAction }} - Seleziona POD/PDR</h3>
              <button class="close-button" @click="closePodPdrSelectionModal">×</button>
            </div>
            <div class="modal-body">
              <div class="pod-pdr-selection" v-if="isPodPdrSelectionRequired">
                <div class="selection-tabs">
                  <button 
                    class="tab-btn" 
                    :class="{ active: selectedTab === 'pod' }"
                    @click="selectedTab = 'pod'"
                  >
                    POD ({{ availablePods.length }})
                  </button>
                  <button 
                    class="tab-btn" 
                    :class="{ active: selectedTab === 'pdr' }"
                    @click="selectedTab = 'pdr'"
                  >
                    PDR ({{ availablePdrs.length }})
                  </button>
                </div>

                <div class="pod-pdr-list" v-if="selectedTab === 'pod'">
                  <div 
                    v-for="pod in availablePods" 
                    :key="pod.cod_pod"
                    class="pod-pdr-item"
                    :class="{ 
                      selected: (isMultiSelectEnabled ? selectedPodPdrs.some(p => p.cod_pod === pod.cod_pod) : selectedPodPdr?.cod_pod === pod.cod_pod),
                      'gestito': pod.esito_gestione && pod.esito_gestione !== null,
                      'non-selezionabile': pod.esito_gestione && pod.esito_gestione !== null && currentAction !== 'Distacca',
                      'ech-point': pod.ech
                    }"
                    @click="selectPodPdr(pod)"
                  >
                    <div class="item-header">
                      <span class="item-code">{{ pod.code }}</span>
                      <span class="item-type">POD</span>
                      <span v-if="pod.esito_gestione" class="gestione-status" :class="pod.esito_gestione">
                        {{ getGestioneStatusLabel(pod.esito_gestione) }}
                      </span>
                    </div>
                    <div class="item-details">
                      <div class="detail-row" v-if="currentAction === 'Distacca' && pod.fatture_contestate && pod.fatture_contestate.length">
                        <span class="detail-label">Fattura contestata:</span>
                        <span class="detail-value contestazione-value">
                          <template v-for="(num, idx) in pod.fatture_contestate" :key="num">
                            <span class="fattura-cliccabile" @click.stop="navigateToFatturaDetail(num)">{{ num }}</span><span v-if="idx < pod.fatture_contestate.length - 1">, </span>
                          </template>
                        </span>
                      </div>
                      <div class="detail-row">
                        <span class="detail-label">Indirizzo:</span>
                        <span class="detail-value">{{ pod.indirizzo || 'Non disponibile' }}</span>
                      </div>
                      <div class="detail-row">
                        <span class="detail-label">Saldo:</span>
                        <span class="detail-value">€ {{ formatCurrency(pod.saldo || 0) }}</span>
                      </div>
                      <div class="detail-row" v-if="pod.type_state_name">
                        <span class="detail-label">Stato:</span>
                        <span class="detail-value">
                          <span class="status-dot stato-default"></span>
                          <span class="status-text">{{ pod.type_state_name }}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="availablePods.length === 0" class="no-items">
                    <i class="pi pi-info-circle"></i>
                    <p>Nessun POD disponibile</p>
                  </div>
                </div>

                <div class="pod-pdr-list" v-if="selectedTab === 'pdr'">
                  <div 
                    v-for="pdr in availablePdrs" 
                    :key="pdr.cod_pdr"
                    class="pod-pdr-item"
                    :class="{ 
                      selected: (isMultiSelectEnabled ? selectedPodPdrs.some(p => p.cod_pdr === pdr.cod_pdr) : selectedPodPdr?.cod_pdr === pdr.cod_pdr),
                      'gestito': pdr.esito_gestione && pdr.esito_gestione !== null,
                      'non-selezionabile': pdr.esito_gestione && pdr.esito_gestione !== null && currentAction !== 'Distacca',
                      'ech-point': pdr.ech
                    }"
                    @click="selectPodPdr(pdr)"
                  >
                    <div class="item-header">
                      <span class="item-code">{{ pdr.code }}</span>
                      <span class="item-type">PDR</span>
                      <span v-if="pdr.esito_gestione" class="gestione-status" :class="pdr.esito_gestione">
                        {{ getGestioneStatusLabel(pdr.esito_gestione) }}
                      </span>
                    </div>
                    <div class="item-details">
                      <div class="detail-row" v-if="currentAction === 'Distacca' && pdr.fatture_contestate && pdr.fatture_contestate.length">
                        <span class="detail-label">Fattura contestata:</span>
                        <span class="detail-value contestazione-value">
                          <template v-for="(num, idx) in pdr.fatture_contestate" :key="num">
                            <span class="fattura-cliccabile" @click.stop="navigateToFatturaDetail(num)">{{ num }}</span><span v-if="idx < pdr.fatture_contestate.length - 1">, </span>
                          </template>
                        </span>
                      </div>
                      <div class="detail-row">
                        <span class="detail-label">Indirizzo:</span>
                        <span class="detail-value">{{ pdr.indirizzo || 'Non disponibile' }}</span>
                      </div>
                      <div class="detail-row">
                        <span class="detail-label">Saldo:</span>
                        <span class="detail-value">€ {{ formatCurrency(pdr.saldo || 0) }}</span>
                      </div>
                      <div class="detail-row" v-if="pdr.type_state_name">
                        <span class="detail-label">Stato:</span>
                        <span class="detail-value">
                          <span class="status-dot stato-default"></span>
                          <span class="status-text">{{ pdr.type_state_name }}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="availablePdrs.length === 0" class="no-items">
                    <i class="pi pi-info-circle"></i>
                    <p>Nessun PDR disponibile</p>
                  </div>
                </div>
              </div>

              <div
                v-if="currentAction === 'Distacca' && !isPodPdrSelectionRequired"
                class="single-point-summary"
              >
                <div
                  v-for="p in puntiDisponibili"
                  :key="p.cod_pod || p.cod_pdr || p.code"
                  class="single-point-summary-row"
                  :class="{ 'ech-point': p.ech }"
                >
                  <div class="single-point-summary-title">
                    <strong>{{ p.code }}</strong>
                    <span class="single-point-summary-type">
                      {{ p.cod_pod ? 'POD' : (p.cod_pdr ? 'PDR' : '') }}
                    </span>
                  </div>
                  <div v-if="p.fatture_contestate && p.fatture_contestate.length">
                    <span class="detail-label">Fattura contestata:</span>
                    <span class="contestazione-value">
                      <template v-for="(num, idx) in p.fatture_contestate" :key="num">
                        <span class="fattura-cliccabile" @click.stop="navigateToFatturaDetail(num)">{{ num }}</span><span v-if="idx < p.fatture_contestate.length - 1">, </span>
                      </template>
                    </span>
                  </div>
                </div>
              </div>

              <div class="action-fields" v-if="(isMultiSelectEnabled ? selectedPodPdrs.length > 0 : selectedPodPdr) || !isPodPdrSelectionRequired">
                <div class="form-group" v-if="currentAction === 'Distacca'">
                  <label for="distacca-note">Note Distacco:</label>
                  <textarea 
                    id="distacca-note"
                    v-model="distaccaData.note" 
                    placeholder="Inserisci le note per il distacco..."
                    class="form-textarea"
                    rows="4"
                  ></textarea>
                </div>

                <div class="form-group" v-if="currentAction === 'Rimanda'">
                  <label for="rimanda-note">Note:</label>
                  <textarea 
                    id="rimanda-note"
                    v-model="rimandaData.note" 
                    placeholder="Inserisci le note per il rimando..."
                    class="form-textarea"
                    rows="4"
                  ></textarea>
                </div>

                <div class="form-group" v-if="currentAction === 'Rimanda'">
                  <label for="rimanda-data">Data di Rimando:</label>
                  <input 
                    type="date" 
                    id="rimanda-data"
                    v-model="rimandaData.dataRimando"
                    :min="today"
                    :max="maxDate"
                    class="form-input"
                  />
                  <small class="form-help">Seleziona una data entro 15 giorni da oggi</small>
                </div>

                <div class="form-group" v-if="currentAction === 'Rilascia in Tutela'">
                  <label for="tutela-note">Note Rilascio:</label>
                  <textarea 
                    id="tutela-note"
                    v-model="tutelaData.note" 
                    placeholder="Inserisci le note per il rilascio in tutela..."
                    class="form-textarea"
                    rows="4"
                  ></textarea>
                </div>

                <div class="form-group" v-if="currentAction === 'Dilaziona'">
                  <label for="dilazione-note">Note Dilazione:</label>
                  <textarea 
                    id="dilazione-note"
                    v-model="dilazioneData.note" 
                    placeholder="Inserisci le note per la dilazione..."
                    class="form-textarea"
                    rows="4"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn-secondary" @click="closePodPdrSelectionModal">Annulla</button>
              <button 
                v-if="currentAction === 'Dilaziona'"
                class="btn-success" 
                @click="openAggiungiDilazioneModal"
              >
                Crea Dilazioni
              </button>
              <button 
                class="btn-primary" 
                @click="confermaPodPdrSelection" 
                :disabled="currentAction === 'Distacca' ? false : ((isPodPdrSelectionRequired && ((isMultiSelectEnabled && selectedPodPdrs.length === 0) || (!isMultiSelectEnabled && !selectedPodPdr))) || !isFormValid)"
              >
                Conferma {{ currentAction }}
              </button>
            </div>
          </div>
        </div>

        <div v-if="showAggiungiDilazioneModal" class="modal-overlay" @click="closeAggiungiDilazioneModal">
          <div class="modal-content modal-content-large" @click.stop>
            <div class="modal-header">
              <h3>Aggiungi Dilazione</h3>
              <button class="close-button" @click="closeAggiungiDilazioneModal">×</button>
            </div>
            <div class="modal-body">
              <AggiungiDilazione 
                :data="fattureNumeri"
                @dilazione-creata="handleDilazioneCreata"
                @dilazione-rimossa="handleDilazioneRimossa"
              />
            </div>
          </div>
        </div>

        <div v-if="showDilazioneModal" class="modal-overlay" @click="closeDilazioneModal">
          <div class="modal-content" @click.stop>
            <div class="modal-header">
              <h3>Dilaziona Recupero</h3>
              <button class="close-button" @click="closeDilazioneModal">×</button>
            </div>
            <div class="modal-body">
              <div class="dilazione-question">
                <p>Vuoi procedere con la dilazione del recupero?</p>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn-secondary" @click="closeDilazioneModal">No</button>
              <button class="btn-primary" @click="confermaDilazione">
                Sì, Dilaziona
              </button>
              <button class="btn-success" @click="creaDilazioni">
                Crea Dilazioni
              </button>
            </div>
          </div>
        </div>

        <div v-if="showAddTicketModal" class="modal-overlay" @click="closeAddTicketModal">
          <div class="modal-content" @click.stop>
            <div class="modal-header">
              <h3>Nuovo Ticket</h3>
              <button class="close-button" @click="closeAddTicketModal">×</button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label class="form-label" for="tipoDestinatario">
                  <i class="pi pi-users"></i> Tipo Destinatario
                </label>
                <select id="tipoDestinatario" v-model="newTicket.tipoDestinatario" class="form-input"
                  @change="onChangeTypeRecipient" required>
                  <option v-for="type in typesRecipients" :key="type.code" :value="type.code">
                    {{ type.name }}
                  </option>
                </select>
              </div>



              <div class="form-group" v-if="newTicket.tipoDestinatario && newTicket.tipoDestinatario !== 'area'">
                <label class="form-label">
                  <i class="pi pi-user"></i> Destinatario
                </label>
                <select v-model="newTicket.recipient" class="form-input" required>
                  <option value="">-- Seleziona destinatario --</option>
                  <option v-for="recipient in recipients" :key="recipient.id" :value="recipient">
                    {{ recipient.label || recipient.name }} ({{ recipient.type }})
                  </option>
                </select>
              </div>

              <div class="form-group" v-if="newTicket.tipoDestinatario === 'area'">
                <label class="form-label" for="areaDestinatario">
                  <i class="pi pi-building"></i> Area Destinatario
                </label>
                <select id="areaDestinatario" v-model="newTicket.recipient" class="form-input" required>
                  <option value="">-- Seleziona area --</option>
                  <option v-for="area in ticketAreas" :key="area.id_ticket_area" :value="area">
                    {{ area.area }} ({{ area.code }})
                  </option>
                </select>
              </div>

              <div class="form-group">
                <label for="ticket-title">Titolo</label>
                <input id="ticket-title" v-model="newTicket.title" class="form-input" />
              </div>
              <div class="form-group">
                <label for="ticket-content">Contenuto</label>
                <textarea id="ticket-content" v-model="newTicket.content" class="form-textarea"></textarea>
              </div>

              <div class="form-group">
                <div class="link-entity-toggle">
                  <input type="checkbox" id="toggleLinkEntity" v-model="linkEntityEnabled" />
                  <label class="form-label" for="toggleLinkEntity" style="margin:0;">Collegare il ticket a un pod,pdr,fattura... </label>
                </div>
              </div>

              <div v-if="linkEntityEnabled">
                <div class="form-group">
                  <label class="form-label">Tipo entità</label>
                  <select v-model="linkEntityType" class="form-input" @change="onChangeEntityType">
                    <option value="">-- Seleziona tipo --</option>
                    <option v-for="t in linkEntityTypes" :key="t.id" :value="t">
                      {{ t.label || t.type || t.name }}
                    </option>
                  </select>
                </div>
                <div class="form-group" v-if="linkEntityType">
                  <div style="display:flex; gap:8px; align-items:center;">
                    <input class="form-input" v-model="linkEntitySearch" @input="onSearchEntity" placeholder="Cerca..." />
                  </div>
                  <div v-if="showEntityList && linkEntityOptions.length" class="entity-dropdown">
                    <div 
                      class="entity-item" 
                      v-for="opt in linkEntityOptions" 
                      :key="opt.id || opt.value || opt.code || opt.label"
                      @click="selectEntity(opt)"
                    >
                      {{ opt.label || opt.name || opt.code || opt.numero }} <small>({{ opt.type }})</small>
                    </div>
                  </div> 
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn-secondary" @click="closeAddTicketModal">Annulla</button>
              <button class="btn-primary" @click="confermaNuovoTicket" :disabled="!newTicket.title || !newTicket.content || !newTicket.tipoDestinatario || !newTicket.recipient">
                Crea Ticket
              </button>
            </div>
          </div>
        </div>

        <div v-if="showEmailBonariaDialog" class="modal-overlay" @click="closeEmailBonariaDialog">
          <div class="modal-content modal-large" @click.stop>
            <div class="modal-header">
              <h3>Invia Email Bonaria</h3>
              <button class="close-button" @click="closeEmailBonariaDialog">&times;</button>
            </div>
            <div class="modal-body">
              <div class="fatture-selection-container">
                <p class="selection-info">
                  Seleziona le fatture per cui inviare l'email bonaria al cliente:
                </p>
                
                <div class="fatture-list">
                  <div v-for="fattura in fattureTabella" :key="fattura.numero" class="fattura-item">
                    <label class="fattura-checkbox">
                      <input 
                        type="checkbox" 
                        :value="fattura.numero" 
                        v-model="selectedFattureEmailBonaria"
                      />
                      <span class="checkmark"></span>
                      <div class="fattura-info">
                        <div class="fattura-numero">Fattura {{ fattura.numero }}</div>
                        <div class="fattura-details">
                          <span class="fattura-data">Emissione: {{ formatDateWithMoment(fattura.data_emissione) }}</span>
                          <span class="fattura-data">Scadenza: {{ formatDateWithMoment(fattura.data_scadenza_fattura) }}</span>
                          <span class="fattura-importo">€ {{ Number(fattura.saldo_fattura || 0).toFixed(2) }}</span>
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn-secondary" @click="closeEmailBonariaDialog">
                <i class=""></i> Annulla
              </button>
              <button class="btn-primary" @click="confermaInvioEmailBonaria" :disabled="sendingEmailBonaria">
                <i class="pi pi-spin pi-spinner" v-if="sendingEmailBonaria"></i>
                <i class="" v-else></i>
                {{ sendingEmailBonaria ? 'Invio in corso...' : `Invia Email (${selectedFattureEmailBonaria.length})` }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Service from "@/services/ask-management/recupero-credito-service";
import { ref, onMounted, getCurrentInstance, computed, nextTick, onUnmounted } from "vue";
import Loader from "@/components/Loader.vue";
import { useToast } from "primevue/usetoast";
import moment from "moment";
import RiepilogoMensileInsoluti from '@/components/pratiche/RiepilogoMensileInsoluti.vue';
import AggiungiDilazione from '@/pages/ask/dialogs/operations/fatture-vendita/AggiungiDilazione.vue';
import DilazioniAll from '@/components/ask/pages/dilazioni/All.vue';

export default {
  name: 'RecuperoCredito',
  components: {
    Loader,
    RiepilogoMensileInsoluti,
    AggiungiDilazione,
    DilazioniAll
  },
  setup() {
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    self.$http = self.appContext.config.globalProperties.$http;
    const service = new Service(self.$http, self.$eventBus);
    const toast = useToast();

    const loading = ref(false);
    const error = ref(null);
    const userData = ref(null);
    const fattureData = ref([]);
    const ticketsData = ref([]);
    const currentCredito = ref(null);
    const fattureTabella = ref([]);
    const dettaglioContatto = ref(null);
    const clientData = ref(null);
    const showAddTicketModal = ref(false);
    const newTicket = ref({
      title: '',
      content: '',
      tipoDestinatario: 'area',
      recipient: '',
     
      is_related: false,
      related_contact: {
        contact_id: clientData.value?.id,
        contact_type: 'client'
      }
    });
    const typesRecipients = ref([
      { name: 'Area User', code: 'area' }
    ]);
    const recipients = ref([]);
    const ticketAreas = ref([]);
    const linkEntityEnabled = ref(false);
    const linkEntityTypes = ref([]);
    const linkEntityType = ref('');
    const linkEntityOptions = ref([]);
    const linkEntityTotal = ref(0);
    const linkEntityHasMore = ref(false);
    const linkEntityLimit = ref(10);
    const linkEntityOffset = ref(0);
    const linkEntitySelected = ref('');
    const linkEntitySearch = ref('');
    let linkEntitySearchTimer = null;
      const showEntityList = ref(false);
      const showRimandaModal = ref(false);
      const showDilazioneModal = ref(false);
      const showDistaccaModal = ref(false);
      const showConfermaDilazioneModal = ref(false);
      const dataRimandaConferma = ref(null);
      const selectedPodPdrForDilazione = ref(null);
      const isLastPointForDilazione = ref(false);
    const gestioneCreditoId = ref(null);
    const selectedSection = ref(null);
    const totaleSaldo = ref(null);
    const riepilogoRef = ref(null);
    const currentYear = new Date().getFullYear();
    const previousYear = currentYear - 1;
    const countFatture = ref(0);
    const clientiTipo3Count = ref(0);
    const clientiTotaliCount = ref(0);
    const storicoClienteId = ref(null);
    const tutelaData = ref({ note: '' });
    const rankingSaldo = ref(null);
    const notesRaw = ref('');
    const showAggiungiDilazioneModal = ref(false);
    const fattureNumeri = ref([]);
    const clientIds = ref([]);
    const sourceLabel = ref('');
    const notificaPreavvisi = ref('');
    const showTutelaModal = ref(false);
    const currentClienteId = ref(null);
    const currentRappresentanteId = ref(null);
    const showPodPdrSelectionModal = ref(false);
    const selectedTab = ref('pod');
    const selectedPodPdr = ref(null);
    const selectedPodPdrs = ref([]);
    const currentAction = ref('');
    const currentActionData = ref({});
    const availablePods = ref([]);
    const availablePdrs = ref([]);
    const unmanagedCountAtOpen = ref(0);
    const distaccaData = ref({ note: '', selectedPodPdr: null });
    const rimandaData = ref({ note: '', dataRimando: '', selectedPodPdr: null });
    const dilazioneData = ref({ note: '' });
    const isDistaccaAllowed = ref(true);
    const showEmailBonariaDialog = ref(false);
    const selectedFattureEmailBonaria = ref([]);
    const sendingEmailBonaria = ref(false); 

    const isPodPdrSelectionRequired = computed(() => {
      if (currentAction.value === 'Rimanda') return false;
      const numPods = availablePods.value.length;
      const numPdrs = availablePdrs.value.length;
      const totalPoints = numPods + numPdrs;      
      if (totalPoints === 1) return false;
      return totalPoints > 1;
    });

    const puntiDisponibili = computed(() => [
      ...(availablePods.value || []),
      ...(availablePdrs.value || [])
    ]);

    const isMultiSelectEnabled = computed(() => currentAction.value !== 'Rimanda');

    const isLastPointToManage = computed(() => {
      if (currentAction.value === 'Rimanda') return false;
      
      const totalPunti = availablePods.value.length + availablePdrs.value.length;
      const puntiGestiti = availablePods.value.filter(pod => pod.esito_gestione).length + availablePdrs.value.filter(pdr => pdr.esito_gestione).length;
      const puntiNonGestiti = totalPunti - puntiGestiti;
      const result = puntiNonGestiti === 1 && ['Distacca', 'Dilaziona', 'Rilascia in Tutela'].includes(currentAction.value);

      return result;
    });

    const isFormValid = computed(() => {
      if (currentAction.value === 'Distacca') {
        return true;
      }
      
      if (isPodPdrSelectionRequired.value) {
        if (isMultiSelectEnabled.value) {
          if (selectedPodPdrs.value.length === 0) return false;
        } else if (!selectedPodPdr.value) {
          return false;
        }
      }

      switch (currentAction.value) {
        case 'Rimanda':
          return rimandaData.value.note && rimandaData.value.note.trim() !== '' && 
                 rimandaData.value.dataRimando && rimandaData.value.dataRimando.trim() !== '';
        case 'Rilascia in Tutela':
          return tutelaData.value.note && tutelaData.value.note.trim() !== '';
        case 'Dilaziona':
          return dilazioneData.value.note && dilazioneData.value.note.trim() !== '';
        default:
          return false;
      }
    });

    const parsedNotes = computed(() => {
      const raw = String(notesRaw.value || '').trim();
      if (!raw) return [];
      return raw
        .split('||')
        .map(entry => entry && entry.trim())
        .filter(Boolean)
        .map(entry => {
          const parts = entry.split('::');
          const nome = (parts[0] || '').trim();
          const messaggio = parts.slice(1).join('::').trim();
          return { nome, messaggio };
        })
        .filter(n => n.nome || n.messaggio);
    });

    const privilegiatoText = computed(() => {
      return notificaPreavvisi.value === '0' ? '(privilegiato)' : '';
    });

    const loadUserData = async (userId) => {
      try {
        loading.value = true;
        error.value = null;
        
        const response = await service.getUserDetails(userId);
        if (response && response.data) {
          userData.value = response.data;
        }
      } catch (err) {
        error.value = 'Errore nel caricamento dei dati utente';
        console.error('Errore caricamento utente:', err);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Impossibile caricare i dati dell\'utente',
          life: 3000
        });
      } finally {
        loading.value = false;
      }
    };


    const loadUserTickets = async (userId, userType = 'client') => {
      try {
        loading.value = true;
        const response = await service.getUserTickets(userId, userType);
        if (response && response.success && response.data) {
          ticketsData.value = response.data;
          clientData.value = response.client_data || null;
        } else {
          ticketsData.value = [];
          clientData.value = null;
        }
      } catch (err) {
        ticketsData.value = [];
        clientData.value = null;
        error.value = 'Errore nel caricamento dei ticket';
      } finally {
        loading.value = false;
      }
    };

    const createActionTicket = async (actionType, data, clienteData = null, selectedSectionParam = null) => {
      try {
       
        
        let idAssignedUser = null;
        let userType = null;
        let nomeCliente = '';

        if (clienteData) {
          idAssignedUser = clienteData.id || clienteData.cliente_id || null;
          userType = (selectedSectionParam || selectedSection.value) === 'rappresentante' ? 'rappresentante' : 'client';
          nomeCliente = clienteData.ragsoc || 
                       `${clienteData.nome || ''} ${clienteData.cognome || ''}`.trim() || 
                       ((selectedSectionParam || selectedSection.value) === 'rappresentante' ? 'Rappresentante' : 'Cliente');
        } else {
          if ((selectedSectionParam || selectedSection.value) === 'rappresentante') {
            idAssignedUser = currentCredito.value?.cliente_id || currentCredito.value?.id || null;
            userType = 'rappresentante';
            nomeCliente = currentCredito.value?.ragsoc || 
                         `${currentCredito.value?.nome || ''} ${currentCredito.value?.cognome || ''}`.trim() || 
                         'Rappresentante';
          } else {
            idAssignedUser = currentCredito.value?.cliente_id || currentCredito.value?.id || null;
            userType = 'client';
            nomeCliente = currentCredito.value?.ragsoc || 
                         `${currentCredito.value?.nome || ''} ${currentCredito.value?.cognome || ''}`.trim() || 
                         'Cliente';
          }
        }



        let content = '';
        const puntoLabel = data?.cod_pod || data?.cod_pdr || data?.code ? `\nPunto: ${data.code || data.cod_pod || data.cod_pdr}` : '';
        if (actionType === 'dilazione') {
          content = `Dilazione richiesta per il credito.${puntoLabel}\nNote: ${data.note || 'Nessuna nota aggiuntiva'}`;
        } else if (actionType === 'rimando') {
          content = `Rimando richiesto per il credito.${puntoLabel}\nData rimando: ${data.dataRimando || 'Non specificata'}\nNote: ${data.note || 'Nessuna nota aggiuntiva'}`;
        } else if (actionType === 'distacco') {
          content = `Distacco richiesto per il credito.${puntoLabel}\nNote: ${data.note || 'Nessuna nota aggiuntiva'}`;
        } else if (actionType === 'rilascio in tutela') {
          content = `Rilascio in tutela richiesto per il credito.${puntoLabel}\nNote: ${data.note || 'Nessuna nota aggiuntiva'}`;
        }

        const ticketPayload = {
          title: `${actionType.charAt(0).toUpperCase() + actionType.slice(1)} - ${nomeCliente}`,
          content: content,
          tipoDestinatario: 'area',
          recipient: { id_ticket_area: 2 },
          id_user_to: null,
          id_assigned_user: idAssignedUser,
          id_destinatario: null,
          id_ticket_status: actionType === 'rilascio in tutela' ? 1 : 3,
          user_type: userType,
          is_related: false,
          related_contact: {
            contact_id: idAssignedUser,
            contact_type: userType === 'rappresentante' ? 'Rappresentante' : 'Cliente'
          }
        };


        const ticketResponse = await service.createTicket(ticketPayload);
        if (ticketResponse && ticketResponse.success) {
          console.log(`Ticket ${actionType} creato con successo`);
        } else {
          console.error(`Errore nella creazione del ticket ${actionType}:`, ticketResponse?.message);
        }
      } catch (err) {
        console.error(`Errore nella creazione del ticket ${actionType}:`, err);
      }
    };

    const handleDilazione = async (data, clienteData, selectedSection, selectedPodPdr = null) => {
      try {
        loading.value = true;  
        if (!clienteData?.cliente_id && !clienteData?.id) {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'ID cliente non trovato',
            life: 3000
          });
          return;
        }

        const payload = {
          esito: 1, 
          note: data.note || 'Dilazione richiesta',
          data_rimanda: data.data_rimanda || null,
          ...(data.completato && { completato: data.completato })
        };

        if (selectedPodPdr) {
          if (selectedPodPdr.cod_pod) {
            payload.cod_pod = selectedPodPdr.cod_pod;
          } else if (selectedPodPdr.cod_pdr) {
            payload.cod_pdr = selectedPodPdr.cod_pdr;
          }
        } else {
          console.log('Nessun POD/PDR selezionato');
        }
        
        if (selectedSection === 'cliente') {
          payload.cod_cliente = clienteData.cliente_id || clienteData.id;
        } else if (selectedSection === 'rappresentante') {
          payload.cod_rapp = clienteData.rappresentante_id || clienteData.id;
        }


        if (selectedSection === 'rappresentante') {
          payload.rappresentante_id = clienteData.cliente_id || clienteData.id;
          if (storicoClienteId.value) {
            payload.cliente_id = storicoClienteId.value;
          }
        }
        
        const response = await service.updateGestisciCredito(clienteData.cliente_id || clienteData.id, payload);
        
        if (response && response.success) {
          await createActionTicket('dilazione', { ...data, cod_pod: payload.cod_pod, cod_pdr: payload.cod_pdr, code: selectedPodPdr?.code }, clienteData, selectedSection);
          
        }
      } catch (err) {
        console.error('Errore creazione dilazione:', err);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Impossibile creare la dilazione',
          life: 3000
        });
      } finally {
        loading.value = false;
      }
    };

    const handleRimando = async (data, clienteData, selectedSection, selectedPodPdr = null, { suppressToast = false } = {}) => {
      try {
        loading.value = true;
        
        if (!clienteData?.cliente_id && !clienteData?.id) {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'ID cliente non trovato',
            life: 3000
          });
          return;
        }

        const payload = {
          esito: 2, 
          note: data.note || 'Rimando richiesto',
          data_rimanda: data.dataRimando || null
        };

        if (selectedPodPdr) {
          if (selectedPodPdr.cod_pod) {
            payload.cod_pod = selectedPodPdr.cod_pod;
          } else if (selectedPodPdr.cod_pdr) {
            payload.cod_pdr = selectedPodPdr.cod_pdr;
          }
        }

        if (selectedSection === 'cliente') {
          payload.cod_cliente = clienteData.cliente_id || clienteData.id;
        } else if (selectedSection === 'rappresentante') {
          payload.cod_rapp = clienteData.rappresentante_id || clienteData.id;
        }


        if (selectedSection === 'rappresentante') {
          payload.rappresentante_id = clienteData.cliente_id || clienteData.id;
          if (storicoClienteId.value) {
            payload.cliente_id = storicoClienteId.value;
          }
        }
        
        const response = await service.updateGestisciCredito(clienteData.cliente_id || clienteData.id, payload);
        
        if (response && response.success) {
          await createActionTicket('rimando', { ...data, cod_pod: payload.cod_pod, cod_pdr: payload.cod_pdr, code: selectedPodPdr?.code }, clienteData, selectedSection);
          if (!suppressToast) {
            toast.add({
              severity: 'success',
              summary: 'Successo',
              detail: 'Rimando creato con successo',
              life: 3000
            });
          }
          resetToInitialView();
        }
      } catch (err) {
        console.error('Errore creazione rimando:', err);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Impossibile creare il rimando',
          life: 3000
        });
      } finally {
        loading.value = false;
      }
    };

    const handleDistacco = async (data, clienteData, selectedSection, selectedPodPdr = null, { suppressToast = false } = {}) => {
      try {
        loading.value = true;
        
        if (!clienteData?.cliente_id && !clienteData?.id) {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'ID cliente non trovato',
            life: 3000
          });
          return;
        }

        const payload = {
          esito: 3, 
          note: data.note || 'Distacco richiesto',
          data_rimanda: null,
          ...(data.completato && { completato: data.completato })
        };
        

        if (selectedPodPdr) {
          if (selectedPodPdr.cod_pod) {
            payload.cod_pod = selectedPodPdr.cod_pod;
          } else if (selectedPodPdr.cod_pdr) {
            payload.cod_pdr = selectedPodPdr.cod_pdr;
          }
        } else if (data.completato) {
          const allPoints = [...availablePods.value, ...availablePdrs.value];
          const unmanagedPoint = allPoints.find(point => !point.esito_gestione);
          if (unmanagedPoint) {
            if (unmanagedPoint.cod_pod) {
              payload.cod_pod = unmanagedPoint.cod_pod;
            } else if (unmanagedPoint.cod_pdr) {
              payload.cod_pdr = unmanagedPoint.cod_pdr;
            }
          }
        }

        if (selectedSection === 'cliente') {
          payload.cod_cliente = clienteData.cliente_id || clienteData.id;
        } else if (selectedSection === 'rappresentante') {
          payload.cod_rapp = clienteData.rappresentante_id || clienteData.id;
        }


        if (selectedSection === 'rappresentante') {
          payload.rappresentante_id = clienteData.cliente_id || clienteData.id;
          if (storicoClienteId.value) {
            payload.cliente_id = storicoClienteId.value;
          }
        }
        
        const response = await service.updateGestisciCredito(clienteData.cliente_id || clienteData.id, payload);
        
        if (response && response.success) {
          await createActionTicket('distacco', { ...data, cod_pod: payload.cod_pod, cod_pdr: payload.cod_pdr, code: selectedPodPdr?.code }, clienteData, selectedSection);
          if (!suppressToast) {
            toast.add({
              severity: 'success',
              summary: 'Successo',
              detail: 'Distacco creato con successo',
              life: 3000
            });
          }
          resetToInitialView();
        }
      } catch (err) {
        console.error('Errore creazione distacco:', err);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Impossibile creare il distacco',
          life: 3000
        });
      } finally {
        loading.value = false;
      }
    };

    const formatDateWithMoment = (dateString, format = 'DD/MM/YYYY') => {
      if (!dateString) return '';
      return moment(dateString).format(format);
    };

    const validateData = (data) => {
      if (!data || typeof data !== 'object') {
        return false;
      }
      return true;
    };

    const loadDettaglioContatto = async (id, params) => {
  try {
    loading.value = true;
    const response = await service.getDettaglioContatto(id, params);
    if (response && response.success && response.data) {
      dettaglioContatto.value = response.data;
    } else {
      dettaglioContatto.value = null;
    }
  } catch (err) {
    dettaglioContatto.value = null;
    error.value = 'Errore nel caricamento del contatto';
  } finally {
    loading.value = false;
  }
};

    onMounted(() => {
      self.$eventBus.on('dilazione-cancellata', handleEventBusDilazioneCancellata);
      
      const urlParams = new URLSearchParams(window.location.search);
      const clienteId = urlParams.get('cliente_id');
      const rappresentanteId = urlParams.get('rappresentante_id');
      
      if (clienteId) {
        handleClienteClick(clienteId);
      } else if (rappresentanteId) {
        handleRappresentanteClick(rappresentanteId);
      }
    });

    onUnmounted(() => {
      if (self.$eventBus) {
        self.$eventBus.off('dilazione-cancellata', handleEventBusDilazioneCancellata);
      }
    });

    const loadInitialData = async (userId) => {
      try {
        loading.value = true;
        
        await Promise.all([
          loadUserData(userId),
          loadUserTickets(userId, 'client')
        ]);
        
        toast.add({
          severity: 'success',
          summary: 'Caricamento completato',
          detail: 'Dati caricati con successo',
          life: 2000
        });
        
      } catch (err) {
        console.error('Errore caricamento dati iniziali:', err);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore nel caricamento dei dati iniziali',
          life: 3000
        });
      } finally {
        loading.value = false;
      }
    };

    const confermaNuovoTicket = async () => {
      try {
        loading.value = true;

        const ultimoTicket = ticketsData.value && ticketsData.value.length > 0
          ? ticketsData.value[0]
          : null;

        let idAssignedUser = null;
        let userType = null;

        if (selectedSection.value === 'rappresentante') {
          idAssignedUser = currentCredito.value?.cliente_id || null;
          userType = 'rappresentante';
        } else {
          idAssignedUser = dettaglioContatto.value?.contatto?.id || null;
          userType = 'client';
        }

        const payload = {
          ...newTicket.value,
          id_user_to: ultimoTicket?.id_user_to || null,
          id_assigned_user: idAssignedUser,
          id_destinatario: newTicket.value.recipient?.id || null,
          user_type: userType
        };

        if (linkEntityEnabled.value && linkEntitySelected.value) {
          payload.is_related = true;
          payload.related_entity = {
            id: linkEntitySelected.value.id || linkEntitySelected.value.value || linkEntitySelected.value.code || linkEntitySelected.value.numero || null,
            type: linkEntitySelected.value.type || null,
            label: linkEntitySelected.value.label || linkEntitySelected.value.name || linkEntitySelected.value.code || linkEntitySelected.value.numero || null
          };
        }

        const response = await service.createTicket(payload);
        if (response && response.success) {
          toast.add({
            severity: 'success',
            summary: 'Ticket creato',
            detail: 'Il ticket è stato creato con successo',
            life: 3000
          });
          showAddTicketModal.value = false;
          
          if (selectedSection.value === 'rappresentante') {
            await loadUserTickets(idAssignedUser, 'rappresentante');
          } else {
            const clienteId = dettaglioContatto.value?.contatto?.id || currentCredito.value?.cliente_id || clientData.value?.id;
            await loadUserTickets(clienteId, 'client');
          }
        } else {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: response.message || 'Errore nella creazione del ticket',
            life: 3000
          });
        }
      } catch (err) {
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore nella creazione del ticket',
          life: 3000
        });
      } finally {
        loading.value = false;
      }
    };

    const closeAddTicketModal = () => {
      showAddTicketModal.value = false;
      newTicket.value = {
        title: '',
        content: '',
        tipoDestinatario: 'area',
        recipient: '',
       
        is_related: false,
        related_contact: {
          contact_id: clientData.value?.id,
          contact_type: 'client'
        }
      };
    };

    const onChangeTypeRecipient = async () => {
      try {
        recipients.value = [];
        ticketAreas.value = [];
        newTicket.value.recipient = '';

        if (newTicket.value.tipoDestinatario) {
          const response = await service.getTicketRecipients('', newTicket.value.tipoDestinatario);
          if (response && response.items) {
            if (newTicket.value.tipoDestinatario === 'area') {
              ticketAreas.value = response.items;
            } else {
              recipients.value = response.items;
            }
          }
        }
      } catch (err) {
        console.error('Errore nel caricamento dei destinatari:', err);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Impossibile caricare i destinatari',
          life: 3000
        });
      }
    };

    const onChangeEntityType = async () => {
      try {
        linkEntitySelected.value = '';
        linkEntitySearch.value = '';
        linkEntityOptions.value = [];
        if (!linkEntityType.value) {
          toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Seleziona un tipo entità', life: 2000 });
          return;
        }
        await loadEntityOptions();
      } catch (err) {
        // noop
      }
    };

    const loadEntityOptions = async () => {
      try {
        if (!linkEntityType.value) {
          toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Seleziona un tipo entità', life: 2000 });
          return;
        }
        const { items, total, has_more, limit, offset } = await service.getTicketEntity(
          linkEntitySearch.value || '',
          linkEntityType.value,
          { limit: linkEntityLimit.value, offset: linkEntityOffset.value }
        );
        linkEntityOptions.value = Array.isArray(items) ? items : [];
        linkEntityTotal.value = total;
        linkEntityHasMore.value = has_more;
        linkEntityLimit.value = limit;
        linkEntityOffset.value = offset;
        showEntityList.value = true;
      } catch (err) {
        linkEntityOptions.value = [];
        showEntityList.value = false;
      }
    };

    const onSearchEntity = () => {
      if (linkEntitySearchTimer) clearTimeout(linkEntitySearchTimer);
      linkEntitySearchTimer = setTimeout(() => {
        linkEntityOffset.value = 0;
        loadEntityOptions();
      }, 300);
    };

  

    const selectEntity = (opt) => {
      linkEntitySelected.value = opt;
      linkEntitySearch.value = opt.label || opt.name || opt.code || opt.numero || '';
      showEntityList.value = false;
    };

    const uniqueTickets = computed(() => {
      const seen = new Set();
      const map = new Map();
      ticketsData.value.forEach(ticket => {
        if (!seen.has(ticket.id_ticket)) {
          seen.add(ticket.id_ticket);
          map.set(ticket.id_ticket, ticket);
        }
      });
      return Array.from(map.values());
    });

    const openAddTicketModal = async () => {
      showAddTicketModal.value = true;
      if (newTicket.value.tipoDestinatario === 'area') {
        onChangeTypeRecipient();
      }
      try {
        linkEntityTypes.value = await service.getTypesEntity();
      } catch (err) {
        linkEntityTypes.value = [];
      }
    };

    const navigateToFatturaDetail = (numero) => {
      if (!numero) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Numero fattura non disponibile', life: 2000 });
        return;
      }
      window.open(`/ask/clienti/fatture/${numero}/dettagli`);
    };

    const navigateToClienteDetail = (clienteId) => {
      if (!clienteId) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'ID cliente non disponibile', life: 2000 });
        return;
      }
      window.open(`/ask/clienti/${clienteId}/dettagli`);
    };

    const navigateToPdpDetail = (codPod, codPdr) => {
      if (codPod > 0) {
        window.open(`/ask/pods/${codPod}/dettagli`);
      } else if (codPdr > 0) {
        window.open(`/ask/pdrs/${codPdr}/dettagli`);
      } else {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'ID POD/PDR non disponibile', life: 2000 });
      }
    };

    const resetDashboardData = () => {
      currentCredito.value = null;
      fattureTabella.value = [];
      dettaglioContatto.value = null;
      clientData.value = null;
      ticketsData.value = [];
      countFatture.value = 0;
      clientiTipo3Count.value = 0;
      clientiTotaliCount.value = 0;
      totaleSaldo.value = null;
      sourceLabel.value = '';
      notificaPreavvisi.value = '';
      isDistaccaAllowed.value = false; 
    };

    const handleClienteClick = async (clienteId = null) => {
      resetDashboardData();
      storicoClienteId.value = null;
      selectedSection.value = 'cliente';
      currentClienteId.value = clienteId; 
      currentRappresentanteId.value = null;
      clientIds.value = []; 
      try {
        loading.value = true;
        error.value = null;
        const params = clienteId ? { cliente_id: clienteId } : {};
        const response = await service.getClientiCredito(params);
        
        if (response && response.success) {
          const ranking = response.ranking;
          const dettaglio = response.dettaglio;
          
          const cliente = ranking;
        sourceLabel.value = (response.source || ranking?.source || dettaglio?.source || dettaglio?.data?.source || '').toString();
        notificaPreavvisi.value = (response.notificaPreavvisi || ranking?.notificaPreavvisi || dettaglio?.notificaPreavvisi || dettaglio?.data?.notificaPreavvisi || '').toString();
          const fatture = dettaglio?.data?.fatture || dettaglio?.fatture || [];
          const totale_saldo = dettaglio?.data?.totale_saldo || dettaglio?.totale_saldo || ranking?.saldo || 0;
          const count_fatture = dettaglio?.data?.totale_fatture || dettaglio?.totale_fatture || dettaglio?.count_fatture || 0;
          
          totaleSaldo.value = totale_saldo;
          countFatture.value = count_fatture;
          
          if (cliente) {
            const primaFattura = fatture && fatture.length > 0 ? fatture[0] : null;
            currentCredito.value = primaFattura || cliente;
            notesRaw.value = ranking?.notes || '';
            
            fattureTabella.value = fatture || [];

            try {
              const codPods = Array.from(
                new Set(
                  (fattureTabella.value || [])
                    .filter(f => f.cod_pod && f.cod_pod > 0)
                    .map(f => f.cod_pod)
                )
              );
              const codPdrs = Array.from(
                new Set(
                  (fattureTabella.value || [])
                    .filter(f => f.cod_pdr && f.cod_pdr > 0)
                    .map(f => f.cod_pdr)
                )
              );

              const paramsDistacco = {};
              if (codPods.length > 0) {
                paramsDistacco.cod_pod = codPods;
              }
              if (codPdrs.length > 0) {
                paramsDistacco.cod_pdr = codPdrs;
              }

              if (paramsDistacco.cod_pod || paramsDistacco.cod_pdr) {
                const check = await service.checkDistacco(paramsDistacco);
                if (check && check.success && check.distacco) {
                  const podMap = check.distacco.pod || {};
                  const pdrMap = check.distacco.pdr || {};
                  const hasAnyTrue =
                    Object.values(podMap).some(Boolean) ||
                    Object.values(pdrMap).some(Boolean);
                  isDistaccaAllowed.value = hasAnyTrue;
                } else {
                  isDistaccaAllowed.value = false;
                }
              } else {
                isDistaccaAllowed.value = false;
              }
            } catch (err) {
              console.error('Errore nel checkDistacco (cliente):', err);
              isDistaccaAllowed.value = false;
            }

            const contattoId = cliente.id;
            const clienteId = cliente.id;

            if (contattoId) {
              await loadDettaglioContatto(contattoId, { contattoId });
            } else {
              toast.add({
                severity: 'warn',
                summary: 'Attenzione',
                detail: 'ID contatto non trovato',
                life: 3000
              });
            }

            if (clienteId) {
              await loadUserTickets(clienteId, 'client');
            } else {
              toast.add({
                severity: 'warn',
                summary: 'Attenzione',
                detail: 'ID cliente non trovato',
                life: 3000
              });
            }
            
            prepareClientIds();
          } else {
            toast.add({
              severity: 'info',
              summary: 'Nessun cliente',
              detail: 'Nessun cliente con credito disponibile',
              life: 3000
            });
          }
        } else {
          toast.add({
            severity: 'info',
            summary: 'Nessun cliente',
            detail: response.message || 'Nessun cliente con credito disponibile',
            life: 3000
          });
        }
      } catch (err) {
        console.error('Errore in handleClienteClick:', err);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante il recupero dei clienti con credito',
          life: 3000
        });
      } finally {
        loading.value = false;
      }
    };


    const handleRappresentanteClick = async (rappresentanteId = null, datiPrecaricati = null) => {
      if (!storicoClienteId.value) {
        resetDashboardData();
        storicoClienteId.value = null;
      }
      selectedSection.value = 'rappresentante';
      currentRappresentanteId.value = rappresentanteId; 
      currentClienteId.value = null;
      clientIds.value = []; 
      try {
        loading.value = true;
        error.value = null;
        let response;
        if (datiPrecaricati) {
          response = { success: true, data: datiPrecaricati };
        } else if (rappresentanteId && !isNaN(Number(rappresentanteId))) {
          response = await service.getRappresentantiCredito({ rappresentante_id: Number(rappresentanteId) });
        } else {
          response = await service.getRappresentantiCredito();
        }
        if (response && response.success && (response.data || response.ranking || response.dettaglio)) {
          const ranking = response.ranking;
          const dettaglio = response.dettaglio?.data || response.data;
          
          sourceLabel.value = (response.source || ranking?.source || dettaglio?.source || '').toString();
          notificaPreavvisi.value = (response.notificaPreavvisi || ranking?.notificaPreavvisi || dettaglio?.notificaPreavvisi || dettaglio?.data?.notificaPreavvisi || '').toString();
          const rappresentante = dettaglio?.rappresentante || ranking;
          const clienti = dettaglio?.clienti || [];
          totaleSaldo.value = dettaglio?.totale_saldo || ranking?.saldo || 0;
          countFatture.value = dettaglio?.totale_fatture || dettaglio?.count_fatture || 0;
          clientiTipo3Count.value = response.clienti_tipo_3_count || 0;
          clientiTotaliCount.value = response.clienti_totali_count || dettaglio?.totale_clienti || 0;
          
          if (selectedSection.value === 'rappresentante' && ranking?.saldo) {
            rankingSaldo.value = ranking.saldo;
          } else {
            rankingSaldo.value = null;
          }

          notesRaw.value = ranking?.notes || '';

          currentCredito.value = {
            ragsoc: rappresentante?.name || rappresentante?.rappresentante || '',
            nome: rappresentante?.nome || '',
            cognome: rappresentante?.cognome || '',
            cliente_id: rappresentante?.id || null,
            rappresentante_id: rappresentante?.id || null,
            clienti_tipo_3_count: response.clienti_tipo_3_count || 0,
            clienti_totali_count: response.clienti_totali_count || dettaglio?.totale_clienti || 0,
            clienti: dettaglio?.clienti || []
          };

          let tutteFatture = [];
          if (datiPrecaricati && datiPrecaricati.fatture) {
            tutteFatture = datiPrecaricati.fatture;
          } else {
            clienti.forEach(cliente => {
              if (Array.isArray(cliente.fatture)) {
                tutteFatture = tutteFatture.concat(
                  cliente.fatture.map(fattura => ({
                    ...fattura,
                    cliente_nome: cliente.nome,
                    cliente_cognome: cliente.cognome,
                    cliente_ragsoc: cliente.ragsoc,
                    cliente_id: cliente.id
                  }))
                );
              }
            });
          }
          fattureTabella.value = tutteFatture;

          try {
            const codPods = Array.from(
              new Set(
                (fattureTabella.value || [])
                  .filter(f => f.cod_pod && f.cod_pod > 0)
                  .map(f => f.cod_pod)
              )
            );
            const codPdrs = Array.from(
              new Set(
                (fattureTabella.value || [])
                  .filter(f => f.cod_pdr && f.cod_pdr > 0)
                  .map(f => f.cod_pdr)
              )
            );

            const paramsDistacco = {};
            if (codPods.length > 0) {
              paramsDistacco.cod_pod = codPods;
            }
            if (codPdrs.length > 0) {
              paramsDistacco.cod_pdr = codPdrs;
            }

            if (paramsDistacco.cod_pod || paramsDistacco.cod_pdr) {
              const check = await service.checkDistacco(paramsDistacco);
              if (check && check.success && check.distacco) {
                const podMap = check.distacco.pod || {};
                const pdrMap = check.distacco.pdr || {};
                const hasAnyTrue =
                  Object.values(podMap).some(Boolean) ||
                  Object.values(pdrMap).some(Boolean);
                isDistaccaAllowed.value = hasAnyTrue;
              } else {
                isDistaccaAllowed.value = false;
              }
            } else {
              isDistaccaAllowed.value = false;
            }
          } catch (err) {
            console.error('Errore nel checkDistacco (rappresentante):', err);
            isDistaccaAllowed.value = false;
          }

          if (selectedSection.value === 'rappresentante' && rappresentante && rappresentante.id) {
            await loadDettaglioContatto(rappresentante.id, { rappresentanteId: rappresentante.id });
            if (clienti.length > 0) {
              await loadUserTickets(rappresentante.id, 'rappresentante');
            }
          } else if (clienti.length > 0) {
            const primoCliente = clienti[0];
            if (primoCliente.contatto_id) {
              await loadDettaglioContatto(primoCliente.contatto_id, { contattoId: primoCliente.contatto_id });
            }
            await loadUserTickets(primoCliente.id, 'client');
          }

          await nextTick();
          if (riepilogoRef.value && selectedSection.value === 'rappresentante' && currentCredito.value?.rappresentante_id) {
            riepilogoRef.value.list['selected.representatives'] = [currentCredito.value.rappresentante_id];
            riepilogoRef.value.selectedYear = [new Date(previousYear, 0, 1), new Date(currentYear, 0, 1)];
            await nextTick();
            riepilogoRef.value.searchData();
          }
          
          prepareClientIds();
        } else {
          toast.add({
            severity: 'info',
            summary: 'Nessun rappresentante',
            detail: response.message || 'Nessun rappresentante con credito disponibile',
            life: 3000
          });
        }
      } catch (err) {
        console.error('Errore in handleRappresentanteClick:', err);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante il recupero dei rappresentanti con credito',
          life: 3000
        });
      } finally {
        loading.value = false;
      }
    };

    const handleTutela = () => {
      openPodPdrSelectionModal('Rilascia in Tutela', { note: '' });
    };

    const closeTutelaModal = () => {
      tutelaData.value = { note: '', selectedPodPdr: null };
    };

    const openEmailBonariaDialog = () => {
      selectedFattureEmailBonaria.value = [];
      showEmailBonariaDialog.value = true;
    };

    const closeEmailBonariaDialog = () => {
      showEmailBonariaDialog.value = false;
      selectedFattureEmailBonaria.value = [];
    };

    const confermaInvioEmailBonaria = async () => {
      if (selectedFattureEmailBonaria.value.length === 0) {
        toast.add({ 
          severity: 'warn', 
          summary: 'Attenzione', 
          detail: 'Seleziona almeno una fattura per inviare l\'email bonaria',
          life: 3000 
        });
        return;
      }

      sendingEmailBonaria.value = true;

      try {
        const result = await service.inviaEmailBonaria(selectedFattureEmailBonaria.value);
        
        if (result && result.message) {
          toast.add({ 
            severity: 'success', 
            summary: 'Successo', 
            detail: result.message,
            life: 5000 
          });

          if (result.email_non_trovate && result.email_non_trovate.length > 0) {
            toast.add({ 
              severity: 'warn', 
              summary: 'Attenzione', 
              detail: `Email non trovate per ${result.email_non_trovate.length} clienti`,
              life: 5000 
            });
          }

          closeEmailBonariaDialog();
        }
      } catch (error) {
        console.error('Errore invio email bonarie:', error);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore nell\'invio delle email bonarie',
          life: 3000
        });
      } finally {
        sendingEmailBonaria.value = false;
      }
    };

    const handleRilascioIntutela = async (data, clienteData, selectedSection, selectedPodPdr = null, { suppressToast = false } = {}) => {
      try {
        loading.value = true;

        if (!clienteData?.cliente_id && !clienteData?.id) {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'ID cliente non trovato',
            life: 3000
          });
          return;
        }

        const payload = {
          esito: 4, 
          note: data.note || 'Rilascio in tutela richiesto',
          data_rilascio: new Date().toISOString().split('T')[0],
          ...(data.completato && { completato: data.completato })
        };
        

        if (selectedPodPdr) {
          if (selectedPodPdr.cod_pod) {
            payload.cod_pod = selectedPodPdr.cod_pod;
          } else if (selectedPodPdr.cod_pdr) {
            payload.cod_pdr = selectedPodPdr.cod_pdr;
          }
        } else if (data.completato) {
          const allPoints = [...availablePods.value, ...availablePdrs.value];
          const unmanagedPoint = allPoints.find(point => !point.esito_gestione);
          if (unmanagedPoint) {
            if (unmanagedPoint.cod_pod) {
              payload.cod_pod = unmanagedPoint.cod_pod;
            } else if (unmanagedPoint.cod_pdr) {
              payload.cod_pdr = unmanagedPoint.cod_pdr;
            }
          }
        }
        if (selectedSection === 'cliente') {
          payload.cod_cliente = clienteData.cliente_id || clienteData.id;
        } else if (selectedSection === 'rappresentante') {
          payload.cod_rapp = clienteData.rappresentante_id || clienteData.id;
        }


        if (selectedSection === 'rappresentante') {
          payload.rappresentante_id = clienteData.cliente_id || clienteData.id;
          if (storicoClienteId.value) {
            payload.cliente_id = storicoClienteId.value;
          }
        }

        const response = await service.updateGestisciCredito(clienteData.cliente_id || clienteData.id, payload);

        if (response && response.success) {
          await createActionTicket('rilascio in tutela', { ...data, cod_pod: payload.cod_pod, cod_pdr: payload.cod_pdr, code: selectedPodPdr?.code }, clienteData, selectedSection);
          if (!suppressToast) {
            toast.add({
              severity: 'success',
              summary: 'Successo',
              detail: 'Rilascio in tutela creato con successo',
              life: 3000
            });
          }
          resetToInitialView();
        }
      } catch (err) {
        console.error('Errore creazione rilascio in tutela:', err);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Impossibile creare il rilascio in tutela',
          life: 3000
        });
      } finally {
        loading.value = false;
      }
    };

    const confermaTutela = async () => {
      const puntiNonGestiti = availablePods.value.filter(pod => !pod.esito_gestione).length + availablePdrs.value.filter(pdr => !pdr.esito_gestione).length;
      const isLastPoint = puntiNonGestiti === 1;
      
      const data = { 
        note: tutelaData.value.note,
        ...(isLastPoint && { completato: 1 })
      };
            
      const clienteData = currentCredito.value;
      const selectedPodPdr = tutelaData.value.selectedPodPdr;
      
      
      await handleRilascioIntutela(data, clienteData, selectedSection.value, selectedPodPdr);
      closeTutelaModal();
    };

    const handleTutelaAction = async (data, clienteData, selectedSection) => {
      await createActionTicket('rilascio in tutela', data, clienteData, selectedSection);
      toast.add({
        severity: 'success',
        summary: 'Successo',
        detail: 'Rilascio in tutela creato con successo',
        life: 3000
      });
    };

    const prepareFattureNumeri = () => {
      const numeri = fattureTabella.value.map(fattura => fattura.numero).filter(Boolean);
      fattureNumeri.value = numeri;
      return numeri;
    };

    const prepareClientIds = () => {
      if (selectedSection.value === 'cliente') {
        const clienteId = currentCredito.value?.id || currentCredito.value?.cliente_id;
        clientIds.value = clienteId ? [clienteId] : [];
      } else if (selectedSection.value === 'rappresentante') {
        const uniqueClientIds = [...new Set(fattureTabella.value.map(fattura => fattura.cliente_id).filter(Boolean))];
        clientIds.value = uniqueClientIds;
      } else {
        clientIds.value = [];
      }
      return clientIds.value;
    };

    const openAggiungiDilazioneModal = () => {
      const numeri = prepareFattureNumeri();
      if (numeri.length === 0) {
        toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Nessuna fattura disponibile per la dilazione',
          life: 3000
        });
        return;
      }
      closePodPdrSelectionModal();
      showAggiungiDilazioneModal.value = true;
    };

    const closeAggiungiDilazioneModal = () => {
      showAggiungiDilazioneModal.value = false;
      fattureNumeri.value = [];
    };

    const closeDilazioneModal = () => {
      showDilazioneModal.value = false;
    };

    const confermaDilazione = async () => {
      const data = { note: 'Dilazione richiesta' };
      const clienteData = currentCredito.value;
      const selectedSectionParam = selectedSection.value;
      const selectedPodPdr = currentActionData.value.selectedPodPdr;
      
      try {
        await handleDilazione(data, clienteData, selectedSectionParam, selectedPodPdr);
        closeDilazioneModal();
        toast.add({
          severity: 'success',
          summary: 'Successo',
          detail: 'Ticket di dilazione creato con successo',
          life: 3000
        });
        
        resetToInitialView();
      } catch (err) {
        console.error('Errore nella creazione del ticket di dilazione:', err);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore nella creazione del ticket di dilazione',
          life: 3000
        });
      }
    };

    const creaDilazioni = () => {
      openAggiungiDilazioneModal();
      closeDilazioneModal();
    };

    const handleDilazioneCreata = async (event) => {
      if (event.success) {
        toast.add({
          severity: 'success',
          summary: 'Successo',
          detail: '',
          life: 3000
        });
        
        closeAggiungiDilazioneModal();
        
        await refreshCurrentData();
      }
    };

    const handleDilazioneRimossa = async (event) => {
      if (event.success) {
        toast.add({
          severity: 'info',
          summary: 'Info',
          detail: 'Dilazione rimossa',
          life: 3000
        });
        
        closeAggiungiDilazioneModal();
        
        await refreshCurrentData();
      }
    };

    const handleDilazioneCancellata = async (event) => {
      if (event.success) {
        toast.add({
          severity: 'success',
          summary: 'Successo',
          detail: 'Dilazione cancellata con successo',
          life: 3000
        });
        
        await refreshCurrentData();
      }
    };

    const refreshCurrentData = async () => {
      try {
        loading.value = true;
        
        if (selectedSection.value === 'cliente') {
          await handleClienteClick(currentClienteId.value);
        } else if (selectedSection.value === 'rappresentante') {
          await handleRappresentanteClick(currentRappresentanteId.value);
        }
        
        prepareClientIds();
        
      } catch (err) {
        console.error('Errore nel refresh dei dati:', err);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante l\'aggiornamento dei dati',
          life: 3000
        });
      } finally {
        loading.value = false;
      }
    };

    const resetToInitialView = () => {
      
      selectedSection.value = null;
      currentCredito.value = null;
      fattureTabella.value = [];
      dettaglioContatto.value = null;
      clientData.value = null;
      ticketsData.value = [];
      clientIds.value = [];
      sourceLabel.value = '';
      notificaPreavvisi.value = '';
      totaleSaldo.value = null;
      countFatture.value = 0;
      clientiTipo3Count.value = 0;
      clientiTotaliCount.value = 0;
      rankingSaldo.value = null;
      storicoClienteId.value = null;
      notesRaw.value = '';
      currentClienteId.value = null;
      currentRappresentanteId.value = null;
      isDistaccaAllowed.value = false; 
    };

    const preparePodPdrData = () => {    
      const pods = [];
      const pdrs = [];

      const contestazioniPodMap = {};
      const contestazioniPdrMap = {};
      const echPodMap = {};
      const echPdrMap = {};

      (fattureTabella.value || []).forEach(f => {
        if (!f) return;
        const numero = f.numero;
        if (!numero) return;

        const isContestata =
          f.contestazione === 1 ||
          f.contestazione === '1' ||
          f.contestazione === true;

        if (Number(f.ech) === 1) {
          if (f.cod_pod && f.cod_pod > 0) {
            echPodMap[f.cod_pod] = true;
          }
          if (f.cod_pdr && f.cod_pdr > 0) {
            echPdrMap[f.cod_pdr] = true;
          }
        }

        if (!isContestata) return;

        if (f.cod_pod && f.cod_pod > 0) {
          if (!contestazioniPodMap[f.cod_pod]) contestazioniPodMap[f.cod_pod] = new Set();
          contestazioniPodMap[f.cod_pod].add(numero);
        }
        if (f.cod_pdr && f.cod_pdr > 0) {
          if (!contestazioniPdrMap[f.cod_pdr]) contestazioniPdrMap[f.cod_pdr] = new Set();
          contestazioniPdrMap[f.cod_pdr].add(numero);
        }
      });

      const getContestazioni = (map, key) => (map && map[key] ? Array.from(map[key]) : []);

      fattureTabella.value.forEach(fattura => {
        if (fattura.cod_pod && fattura.cod_pod > 0) {
          const existingPod = pods.find(p => p.cod_pod === fattura.cod_pod);
          if (!existingPod) {
            pods.push({
              cod_pod: fattura.cod_pod,
              code: fattura.code || `POD${fattura.cod_pod}`, 
              indirizzo: fattura.indirizzo_cliente_completo,
              saldo: fattura.saldo_fattura,
              fatture_contestate: getContestazioni(contestazioniPodMap, fattura.cod_pod),
              esito_gestione: fattura.esito_gestione || null,
              type_state_name: fattura.type_state_name || null,
              ech: echPodMap[fattura.cod_pod] === true
            });
          }
        }
        if (fattura.cod_pdr && fattura.cod_pdr > 0) {
          const existingPdr = pdrs.find(p => p.cod_pdr === fattura.cod_pdr);
          if (!existingPdr) {
            pdrs.push({
              cod_pdr: fattura.cod_pdr,
              code: fattura.code || `PDR${fattura.cod_pdr}`,
              indirizzo: fattura.indirizzo_cliente_completo,
              saldo: fattura.saldo_fattura,
              fatture_contestate: getContestazioni(contestazioniPdrMap, fattura.cod_pdr),
              esito_gestione: fattura.esito_gestione || null,
              type_state_name: fattura.type_state_name || null,
              ech: echPdrMap[fattura.cod_pdr] === true
            });
          }
        }
      });

      if (dettaglioContatto.value?.pods_summary?.pods) {
        dettaglioContatto.value.pods_summary.pods.forEach(pod => {
          if (pod.cod_pod && !pods.find(p => p.cod_pod === pod.cod_pod)) {
            const fatturaCorrispondente = fattureTabella.value.find(f => f.cod_pod === pod.cod_pod);
            pods.push({
              cod_pod: pod.cod_pod,
              code: pod.code || pod.cod_pod || `POD${pod.cod_pod}`, 
              indirizzo: pod.indirizzo_unito || pod.indirizzo,
              saldo: pod.saldo || 0,
              fatture_contestate: getContestazioni(contestazioniPodMap, pod.cod_pod),
              esito_gestione: pod.esito_gestione || null,
              type_state_name: fatturaCorrispondente?.type_state_name || null,
              ech: echPodMap[pod.cod_pod] === true
            });
          }
        });
      }

      if (dettaglioContatto.value?.pods_summary?.pdr) {
        dettaglioContatto.value.pods_summary.pdr.forEach(pdr => {
          if (pdr.cod_pdr && !pdrs.find(p => p.cod_pdr === pdr.cod_pdr)) {
            const fatturaCorrispondente = fattureTabella.value.find(f => f.cod_pdr === pdr.cod_pdr);
            pdrs.push({
              cod_pdr: pdr.cod_pdr,
              code: pdr.code || pdr.cod_pdr || `PDR${pdr.cod_pdr}`, 
              indirizzo: pdr.indirizzo_unito || pdr.indirizzo,
              saldo: pdr.saldo || 0,
              fatture_contestate: getContestazioni(contestazioniPdrMap, pdr.cod_pdr),
              esito_gestione: pdr.esito_gestione || null,
              type_state_name: fatturaCorrispondente?.type_state_name || null,
              ech: echPdrMap[pdr.cod_pdr] === true
            });
          }
        });
      }

      availablePods.value = pods;
      availablePdrs.value = pdrs;
      
    };

    const openPodPdrSelectionModal = async (action, actionData = {}) => {
      console.log('[RECUPERO] openPodPdrSelectionModal - action:', action, 'actionData:', actionData);
      currentAction.value = action;
      currentActionData.value = actionData;
      selectedPodPdr.value = null;
      selectedPodPdrs.value = [];
      selectedTab.value = 'pod';

      preparePodPdrData();
      console.log('[RECUPERO] POD/PDR disponibili dopo preparePodPdrData', {
        availablePods: availablePods.value,
        availablePdrs: availablePdrs.value
      });

      if (action === 'Distacca') {
        try {
          const codPods = Array.from(
            new Set(availablePods.value.map(p => p.cod_pod).filter(Boolean))
          );
          const codPdrs = Array.from(
            new Set(availablePdrs.value.map(p => p.cod_pdr).filter(Boolean))
          );

          const paramsDistacco = {};
          if (codPods.length > 0) paramsDistacco.cod_pod = codPods;
          if (codPdrs.length > 0) paramsDistacco.cod_pdr = codPdrs;

          if (paramsDistacco.cod_pod || paramsDistacco.cod_pdr) {
            const check = await service.checkDistacco(paramsDistacco);

            if (check && check.success && check.distacco) {
              const podMap = check.distacco.pod || {};
              const pdrMap = check.distacco.pdr || {};

              availablePods.value = availablePods.value.filter(p => podMap[p.cod_pod] === true);
              availablePdrs.value = availablePdrs.value.filter(p => pdrMap[p.cod_pdr] === true);
            } else {
              availablePods.value = [];
              availablePdrs.value = [];
            }
          }

          const totalDistaccabili = availablePods.value.length + availablePdrs.value.length;
          if (totalDistaccabili === 0) {
            toast.add({
              severity: 'info',
              summary: 'Nessun punto distaccabile',
              detail: 'Non ci sono POD/PDR su cui è possibile effettuare il distacco',
              life: 4000
            });
            showPodPdrSelectionModal.value = false;
            return;
          }
        } catch (err) {
          console.error('Errore nel checkDistacco per dialog Distacca:', err);
          availablePods.value = [];
          availablePdrs.value = [];
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Errore nel recupero dei punti distaccabili',
            life: 4000
          });
          showPodPdrSelectionModal.value = false;
          return;
        }
      }

      unmanagedCountAtOpen.value =
        availablePods.value.filter(p => !p.esito_gestione).length +
        availablePdrs.value.filter(p => !p.esito_gestione).length;
      console.log('[RECUPERO] unmanagedCountAtOpen:', unmanagedCountAtOpen.value);

      const totalPoints = availablePods.value.length + availablePdrs.value.length;
      console.log('[RECUPERO] totalPoints:', totalPoints);

      if (action === 'Distacca' && totalPoints === 1) {
        const unicoPunto = availablePods.value[0] || availablePdrs.value[0] || null;
        if (unicoPunto) {
          selectedPodPdr.value = unicoPunto;
          console.log('[RECUPERO] Distacca con un solo punto - preselezionato:', unicoPunto);
        }
      }

      if (availablePods.value.length === 0 && availablePdrs.value.length > 0) {
        selectedTab.value = 'pdr';
      } else {
        selectedTab.value = 'pod';
      }
      console.log('[RECUPERO] openPodPdrSelectionModal - tab iniziale:', selectedTab.value);
      showPodPdrSelectionModal.value = true;
    };

    const closePodPdrSelectionModal = () => {
      showPodPdrSelectionModal.value = false;
      selectedPodPdr.value = null;
      selectedPodPdrs.value = [];
      currentAction.value = '';
      currentActionData.value = {};
      availablePods.value = [];
      availablePdrs.value = [];
    };

    const selectPodPdr = (item) => {
      console.log('[RECUPERO] selectPodPdr - currentAction:', currentAction.value, 'item:', item);
      if (item && item.esito_gestione && currentAction.value !== 'Distacca') return; 
      if (isMultiSelectEnabled.value) {
        const key = item.cod_pod ? 'cod_pod' : 'cod_pdr';
        const exists = selectedPodPdrs.value.some(p => p[key] === item[key]);
        if (exists) {
          selectedPodPdrs.value = selectedPodPdrs.value.filter(p => p[key] !== item[key]);
        } else {
          selectedPodPdrs.value = [...selectedPodPdrs.value, item];
        }
      } else {
        if (selectedPodPdr.value && 
            ((item.cod_pod && selectedPodPdr.value.cod_pod === item.cod_pod) ||
             (item.cod_pdr && selectedPodPdr.value.cod_pdr === item.cod_pdr))) {
          selectedPodPdr.value = null;
        } else {
          selectedPodPdr.value = item;
        }
      }
      console.log('[RECUPERO] selectPodPdr - selectedPodPdr:', selectedPodPdr.value, 'selectedPodPdrs:', selectedPodPdrs.value);
    };

    const dilazioniComponentRef = ref(null);

      const getDataPrimaRataPiuVicina = () => {
        const dilazioniComponent = dilazioniComponentRef.value;
        
        if (!dilazioniComponent || !dilazioniComponent.data?.dilazioni) {
          return null;
        }

        const dilazioni = dilazioniComponent.data.dilazioni;
        const oggi = new Date();
        
        const dilazioniConDate = dilazioni
          .filter(dilazione => dilazione.data_prima_rata)
          .map(dilazione => {
            const dataPrimaRata = new Date(dilazione.data_prima_rata);
            const differenzaGiorni = Math.abs(dataPrimaRata - oggi);
            
            return {
              ...dilazione,
              dataPrimaRata,
              differenzaGiorni
            };
          })
          .sort((a, b) => a.differenzaGiorni - b.differenzaGiorni); 

        if (dilazioniConDate.length === 0) {
          return null;
        }

        const dilazionePiuVicina = dilazioniConDate[0];
        return dilazionePiuVicina.data_prima_rata;
      };

    const confermaPodPdrSelection = async () => {
      if (isPodPdrSelectionRequired.value && ((isMultiSelectEnabled.value && selectedPodPdrs.value.length === 0) || (!isMultiSelectEnabled.value && !selectedPodPdr.value))) {
        console.log('[RECUPERO] confermaPodPdrSelection BLOCCATA - nessun punto selezionato', {
          isPodPdrSelectionRequired: isPodPdrSelectionRequired.value,
          isMultiSelectEnabled: isMultiSelectEnabled.value,
          selectedPodPdr: selectedPodPdr.value,
          selectedPodPdrs: selectedPodPdrs.value
        });
        toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Seleziona un POD o PDR',
          life: 3000
        });
        return;
      }

      const clienteData = currentCredito.value;
      const selectedSectionParam = selectedSection.value;
      console.log('[RECUPERO] confermaPodPdrSelection - currentAction:', currentAction.value, {
        clienteData,
        selectedSectionParam,
        selectedPodPdr: selectedPodPdr.value,
        selectedPodPdrs: selectedPodPdrs.value,
        availablePods: availablePods.value,
        availablePdrs: availablePdrs.value,
        unmanagedCountAtOpen: unmanagedCountAtOpen.value
      });

      try {
        switch (currentAction.value) {
          case 'Dilaziona': {
            const dataPrimaRataPiuVicina = getDataPrimaRataPiuVicina();
            
            const isLastPoint = isMultiSelectEnabled.value ? (selectedPodPdrs.value.length === unmanagedCountAtOpen.value) : (unmanagedCountAtOpen.value === 1);
            
            dataRimandaConferma.value = dataPrimaRataPiuVicina;
            selectedPodPdrForDilazione.value = isMultiSelectEnabled.value ? [...selectedPodPdrs.value] : selectedPodPdr.value;
            isLastPointForDilazione.value = isLastPoint;

            closePodPdrSelectionModal();
            showConfermaDilazioneModal.value = true;
            break;
          }
          case 'Rimanda': {
            const data = {
              note: rimandaData.value.note,
              dataRimando: rimandaData.value.dataRimando
            };
            await handleRimando(data, clienteData, selectedSectionParam, selectedPodPdr.value, { suppressToast: true });
            closePodPdrSelectionModal();
            toast.add({
              severity: 'success',
              summary: 'Successo',
              detail: 'Rimando creato con successo',
              life: 3000
            });
            resetToInitialView();
            break;
          }
          case 'Distacca': {
            console.log('[RECUPERO] confermaPodPdrSelection - entra in Distacca');
            try {
              let distaccaPermesso = true;
              let messaggioErrore = '';
              
              if (isMultiSelectEnabled.value && selectedPodPdrs.value.length > 0) {
                for (const point of selectedPodPdrs.value) {
                  const params = {};
                  if (point.cod_pod) params.cod_pod = point.cod_pod;
                  if (point.cod_pdr) params.cod_pdr = point.cod_pdr;
                  
                  if (params.cod_pod || params.cod_pdr) {
                    const volturaInfo = await service.getInfoClienteVoltura(params);
                    
                    if (selectedSectionParam === 'rappresentante' && volturaInfo && volturaInfo.success && volturaInfo.cliente) {
                      const clienteVolturaId = volturaInfo.cliente.id;
                      const clientiRappresentante = clienteData.clienti || [];
                      const clienteTrovato = clientiRappresentante.find(c => c.id === clienteVolturaId || c.cliente_id === clienteVolturaId);
                      
                      if (!clienteTrovato) {
                        distaccaPermesso = false;
                        const tipoPoint = point.cod_pod ? 'POD' : 'PDR';
                        const codePoint = point.code || 'N/A';
                        messaggioErrore = `Il contratto del ${tipoPoint}: ${codePoint} appartiene a un cliente attualmente diverso.`;
                        break;
                      }
                    }
                  }
                }
              } else if (selectedPodPdr.value) {
                const params = {};
                if (selectedPodPdr.value.cod_pod) params.cod_pod = selectedPodPdr.value.cod_pod;
                if (selectedPodPdr.value.cod_pdr) params.cod_pdr = selectedPodPdr.value.cod_pdr;
                
                if (params.cod_pod || params.cod_pdr) {
                  const volturaInfo = await service.getInfoClienteVoltura(params);
                  console.log('[RECUPERO] Distacca - info voltura punto multiplo', { params, volturaInfo });
                  console.log('[RECUPERO] Distacca - info voltura punto singolo', { params, volturaInfo });
                  
                  if (selectedSectionParam === 'rappresentante' && volturaInfo && volturaInfo.success && volturaInfo.cliente) {
                    const clienteVolturaId = volturaInfo.cliente.id;
                    const clientiRappresentante = clienteData.clienti || [];
                    const clienteTrovato = clientiRappresentante.find(c => c.id === clienteVolturaId || c.cliente_id === clienteVolturaId);
                    
                    if (!clienteTrovato) {
                      distaccaPermesso = false;
                      const tipoPoint = selectedPodPdr.value.cod_pod ? 'POD' : 'PDR';
                      const codePoint = selectedPodPdr.value.code || 'N/A';
                      messaggioErrore = `Il contratto del ${tipoPoint}: ${codePoint} appartiene a un cliente attualmente diverso.`;
                    }
                  }
                }
              }
              
              if (!distaccaPermesso) {
                console.log('[RECUPERO] Distacca BLOCCATO per distaccaPermesso=false, messaggioErrore:', messaggioErrore);
                toast.add({
                  severity: 'warn',
                  summary: 'Attenzione',
                  detail: messaggioErrore,
                  life: 5000
                });
                return;
              }
              
            } catch (error) {
              console.error('Errore nella chiamata getInfoClienteVoltura:', error);
            }

            const data = {
              note: distaccaData.value.note,
              ...(isMultiSelectEnabled.value ? {} : (isLastPointToManage.value && { completato: 1 }))
            };
            console.log('[RECUPERO] Distacca - payload base data:', data);
            
            if (isMultiSelectEnabled.value) {
              const unmanagedPoints = [
                ...availablePods.value.filter(p=>!p.esito_gestione),
                ...availablePdrs.value.filter(p=>!p.esito_gestione)
              ];
              let pointsToSend;
              if (selectedPodPdrs.value.length > 0) {
                pointsToSend = selectedPodPdrs.value;
              } else if (selectedPodPdr.value) {
                pointsToSend = [selectedPodPdr.value];
              } else {
                pointsToSend = unmanagedPoints;
              }
              const allSelected = pointsToSend.length === unmanagedCountAtOpen.value;
              console.log('[RECUPERO] Distacca - multiSelect', { unmanagedPoints, pointsToSend, allSelected });
              for (let i = 0; i < pointsToSend.length; i++) {
                const punto = pointsToSend[i];
                const isLast = i === pointsToSend.length - 1;
                const payload = allSelected && isLast ? { ...data, completato: 1 } : { ...data, completato: undefined };
                console.log('[RECUPERO] Distacca - handleDistacco multi, index:', i, 'punto:', punto, 'payload:', payload);
                await handleDistacco(payload, clienteData, selectedSectionParam, punto, { suppressToast: true });
              }
            } else {
              console.log('[RECUPERO] Distacca - handleDistacco singolo', {
                data,
                punto: selectedPodPdr.value
              });
              await handleDistacco(data, clienteData, selectedSectionParam, selectedPodPdr.value);
            }
            closePodPdrSelectionModal();
            toast.add({
              severity: 'success',
              summary: 'Successo',
              detail: 'Distacco creato con successo',
              life: 3000
            });
            resetToInitialView();
            break;
          }
          case 'Rilascia in Tutela': {
            const data = {
              note: tutelaData.value.note,
              ...(isMultiSelectEnabled.value ? {} : (isLastPointToManage.value && { completato: 1 }))
            };

            if (isMultiSelectEnabled.value) {
              const unmanagedPoints = [
                ...availablePods.value.filter(p=>!p.esito_gestione),
                ...availablePdrs.value.filter(p=>!p.esito_gestione)
              ];
              const pointsToSend = selectedPodPdrs.value.length > 0 ? selectedPodPdrs.value : unmanagedPoints;
              const allSelected = pointsToSend.length === unmanagedCountAtOpen.value;
              for (let i = 0; i < pointsToSend.length; i++) {
                const punto = pointsToSend[i];
                const isLast = i === pointsToSend.length - 1;
                const payload = allSelected && isLast ? { ...data, completato: 1 } : { ...data, completato: undefined };
                await handleRilascioIntutela(payload, clienteData, selectedSectionParam, punto, { suppressToast: true });
              }
            } else {
              await handleRilascioIntutela(data, clienteData, selectedSectionParam, selectedPodPdr.value);
            }
            closePodPdrSelectionModal();
            toast.add({
              severity: 'success',
              summary: 'Successo',
              detail: 'Rilascio in tutela creato con successo',
              life: 3000
            });
            resetToInitialView();
            break;
          }
        }
      } catch (err) {
        console.error('Errore nell\'esecuzione dell\'azione:', err);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante l\'esecuzione dell\'azione',
          life: 3000
        });
      }
    };

   
    const handleEventBusDilazioneCancellata = async (event) => {
      if (event.type === 'dilazione-cancellata' && event.success) {
        toast.add({
          severity: 'success',
          summary: 'Successo',
          detail: 'Dilazione cancellata con successo',
          life: 3000
        });
        

        await refreshCurrentData();
      }
    };

    return {
      loading,
      error,
      userData,
      fattureData,
      ticketsData,
      currentCredito,
      fattureTabella,
      dettaglioContatto,
      clientData,
      sourceLabel,
      notificaPreavvisi,
      privilegiatoText,
      countFatture,
      clientiTipo3Count,
      clientiTotaliCount,
      service, 
      
      loadUserData,
      loadUserTickets,
      loadInitialData,
      handleDilazione,
      handleRimando,
      handleDistacco,
      createActionTicket,
      formatDateWithMoment,
      validateData,
      loadDettaglioContatto,
      handleRilascioIntutela,
      getDataPrimaRataPiuVicina,
      dilazioniComponentRef,

      showAddTicketModal,
      newTicket,
      confermaNuovoTicket,
        closeAddTicketModal,
        showRimandaModal,
        showDilazioneModal,
        showDistaccaModal,
        showConfermaDilazioneModal,
        dataRimandaConferma,
        selectedPodPdrForDilazione,
        isLastPointForDilazione,
      gestioneCreditoId,
      typesRecipients,
      recipients,
      ticketAreas,
      onChangeTypeRecipient,
      uniqueTickets,
      openAddTicketModal,
      navigateToFatturaDetail,
      navigateToClienteDetail,
      navigateToPdpDetail,
      selectedSection,
      handleClienteClick,
      totaleSaldo,
      rankingSaldo,
      handleRappresentanteClick,
      riepilogoRef,
      storicoClienteId,
      tutelaData,
      handleTutela,
      closeTutelaModal,
      confermaTutela,
      parsedNotes,
      handleTutelaAction,
      showEmailBonariaDialog,
      selectedFattureEmailBonaria,
      sendingEmailBonaria,
      openEmailBonariaDialog,
      closeEmailBonariaDialog,
      confermaInvioEmailBonaria,
      openAggiungiDilazioneModal,
      closeAggiungiDilazioneModal,
      closeDilazioneModal,
      confermaDilazione,
      showAggiungiDilazioneModal,
      fattureNumeri,
      clientIds,
      creaDilazioni,
      previousYear,
      currentYear,
      handleDilazioneCreata,
      handleDilazioneRimossa,
      handleDilazioneCancellata,
      refreshCurrentData,
      handleEventBusDilazioneCancellata,
      resetToInitialView,
      preparePodPdrData,
      openPodPdrSelectionModal,
      closePodPdrSelectionModal,
      selectPodPdr,
      confermaPodPdrSelection,
      showTutelaModal,
      showPodPdrSelectionModal,
      selectedTab,
      selectedPodPdr,
      selectedPodPdrs,
      currentAction,
      currentActionData,
      availablePods,
      availablePdrs,
      puntiDisponibili,
      isPodPdrSelectionRequired,
      isMultiSelectEnabled,
      isLastPointToManage,
      isFormValid,
      isDistaccaAllowed,
      distaccaData,
      rimandaData,
      dilazioneData,
      linkEntityEnabled,
      linkEntityTypes,
      linkEntityType,
      linkEntityOptions,
      linkEntitySelected,
      linkEntitySearch,
      showEntityList,
      onChangeEntityType,
      onSearchEntity,
      loadEntityOptions,
      selectEntity
    };
  },
  data() {
    return {
      searchQuery: '',
      currentPageTickets: 1,
      currentPageFatture: 1,
      itemsPerPage: 10,
      showTicketModal: false,
      selectedTicket: {},
      numeroFatture: 47,
      selectedUser: {

      },
      tickets: [
       
      ],
      fatture: [
       
      ],
      sortKey: '',
      sortAsc: true,
    }
  },
  computed: {
    filteredTickets() {
      if (!this.searchQuery) return this.tickets;
      
      const query = this.searchQuery.toLowerCase();
      return this.tickets.filter(ticket => 
        ticket.tipo.toLowerCase().includes(query) ||
        ticket.autore.toLowerCase().includes(query) ||
        ticket.statoPdp.toLowerCase().includes(query) ||
        ticket.ragioneSociale.toLowerCase().includes(query) ||
        this.selectedUser.codiceFiscale.toLowerCase().includes(query) ||
        this.selectedUser.pdp.toLowerCase().includes(query)
      );
    },
    filteredTicketsBackend() {
      if (!this.searchQuery) return this.ticketsData;
      
      const query = this.searchQuery.toLowerCase();
      return this.ticketsData.filter(ticket => 
        ticket.tipo.toLowerCase().includes(query) ||
        ticket.autore.toLowerCase().includes(query) ||
        ticket.statoPdp.toLowerCase().includes(query) ||
        ticket.ragioneSociale.toLowerCase().includes(query) ||
        (this.userData?.codiceFiscale || '').toLowerCase().includes(query) ||
        (this.userData?.pdp || '').toLowerCase().includes(query)
      );
    },
    filteredFatture() {
      if (!this.searchQuery) return this.fatture;
      
      const query = this.searchQuery.toLowerCase();
      return this.fatture.filter(fattura => 
        fattura.pdp.toLowerCase().includes(query) ||
        fattura.ragioneSociale.toLowerCase().includes(query) ||
        fattura.indirizzo.toLowerCase().includes(query) ||
        fattura.nft.toLowerCase().includes(query) ||
        fattura.stato.toLowerCase().includes(query)
      );
    },
    filteredFattureBackend() {
      if (!this.searchQuery) return this.fattureData;
      
      const query = this.searchQuery.toLowerCase();
      return this.fattureData.filter(fattura => 
        fattura.pdp.toLowerCase().includes(query) ||
        fattura.ragioneSociale.toLowerCase().includes(query) ||
        fattura.indirizzo.toLowerCase().includes(query) ||
        fattura.nft.toLowerCase().includes(query) ||
        fattura.stato.toLowerCase().includes(query)
      );
    },
    totalPagesTickets() {
      return Math.ceil(this.filteredTickets.length / this.itemsPerPage);
    },
    totalPagesFatture() {
      return Math.ceil(this.filteredFatture.length / this.itemsPerPage);
    },
    startIndexTickets() {
      return (this.currentPageTickets - 1) * this.itemsPerPage + 1;
    },
    endIndexTickets() {
      return Math.min(this.currentPageTickets * this.itemsPerPage, this.filteredTickets.length);
    },
    startIndexFatture() {
      return (this.currentPageFatture - 1) * this.itemsPerPage + 1;
    },
    endIndexFatture() {
      return Math.min(this.currentPageFatture * this.itemsPerPage, this.filteredFatture.length);
    },
    today() {
      return new Date().toISOString().split('T')[0];
    },
    maxDate() {
      const date = new Date();
      date.setMonth(date.getMonth() + 6);
      return date.toISOString().split('T')[0];
    },
    showNumeroClientiBox() {
      if (this.selectedSection === 'rappresentante') return true;
      if (this.selectedSection === 'storico' && this.currentCredito?.rappresentante_id > 0) return true;
      return false;
    },
    clientiConSaldo() {
      if (!this.currentCredito?.clienti) return [];
      
      try {
        const clienti = this.currentCredito.clienti;
        if (!Array.isArray(clienti)) return [];
        
        return clienti.map(cliente => ({
          nome: cliente.ragsoc || '',
          saldo: parseFloat(cliente.totale_saldo) || 0
        })).filter(cliente => cliente.nome && !isNaN(cliente.saldo));
      } catch (error) {
        console.error('Errore nel parsing dei clienti:', error);
        return [];
      }
    },
  },
  methods: {
    
    navigateToIncall() {
      if (!this.currentCredito) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Nessun dato disponibile per la navigazione',
          life: 3000
        });
        return;
      }

      
      let searchQuery = '';
      if (this.currentCredito.ragsoc) {
        searchQuery = this.currentCredito.ragsoc;
      } else {
        const nome = this.currentCredito.nome || '';
        const cognome = this.currentCredito.cognome || '';
        searchQuery = `${nome} ${cognome}`.trim();
      }

      if (!searchQuery) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Nome non disponibile per la ricerca',
          life: 3000
        });
        return;
      }

      const searchType = this.selectedSection; 
      const incallUrl = `/in-call?search_type=${encodeURIComponent(searchType)}&q=${encodeURIComponent(searchQuery)}`;
      
      window.open(incallUrl, '_blank');
    },

    formatCurrency(amount) {
      return new Intl.NumberFormat('it-IT', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    },
    getSaldoClass(saldo) {
      const amount = parseFloat(saldo);
      if (amount > 0) {
        return 'saldo-positivo';
      } else if (amount < 0) {
        return 'saldo-negativo';
      }
      return 'saldo-zero';
    },
    formatDate(dateString) {
      if (!dateString || dateString === null || dateString === undefined || dateString === '') {
        return '';
      }
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return '';
      }
      return date.toLocaleDateString('it-IT');
    },
    getGestioneStatusLabel(esitoGestione) {
      const statusLabels = {
        'distacca': 'Richiesta Di Distacco',
        'rimanda': 'Rimandato',
        'dilaziona': 'Dilazionato',
        'tutela': 'In Tutela',
        'risolto': 'Risolto'
      };
      return statusLabels[esitoGestione] || esitoGestione;
    },
    getTelefonoValido(dettaglioContatto) {
      const numeri = [
        dettaglioContatto?.contatto?.tel,
        dettaglioContatto?.contatto?.cell,
        dettaglioContatto?.contatto?.telefono,
        dettaglioContatto?.contatto?.telefono_unito,
        
        dettaglioContatto?.rappresentante?.telefono,
        dettaglioContatto?.rappresentante?.cellulare,
        
        ...(Array.isArray(dettaglioContatto?.clienti) 
          ? dettaglioContatto.clienti.map(cliente => cliente.telefono).filter(Boolean)
          : []),
        ...(Array.isArray(dettaglioContatto?.clienti) 
          ? dettaglioContatto.clienti.map(cliente => cliente.cellulare).filter(Boolean)
          : []),
        ...(Array.isArray(dettaglioContatto?.clienti) 
          ? dettaglioContatto.clienti.map(cliente => cliente.telefono_unito).filter(Boolean)
          : []),
        
        dettaglioContatto?.clienti?.[0]?.telefono_unito,
        dettaglioContatto?.clienti?.[0]?.telefono,
        
        Array.isArray(dettaglioContatto?.pods_summary?.pods)
          ? dettaglioContatto.pods_summary.pods.find(p => p.telefono_unito)?.telefono_unito
          : null,
        Array.isArray(dettaglioContatto?.pods_summary?.pdr)
          ? dettaglioContatto.pods_summary.pdr.find(p => p.telefono_unito)?.telefono_unito
          : null
      ];
      
      const numeroValido = numeri.find(num => 
        num && 
        num !== '0000000000' && 
        num !== '000000' && 
        num !== '0' && 
        num !== '-' && 
        num.trim() !== '' &&
        num.length >= 8
      );
      
      return numeroValido || 'Non disponibile';
    },
    
    getEmailValida(dettaglioContatto) {
      const emails = [
        dettaglioContatto?.contatto?.email,
        dettaglioContatto?.clienti?.[0]?.email,
        ...(Array.isArray(dettaglioContatto?.pods_summary?.pods)
          ? dettaglioContatto.pods_summary.pods.map(p => p.email_unito)
          : []),
        ...(Array.isArray(dettaglioContatto?.pods_summary?.pdr)
          ? dettaglioContatto.pods_summary.pdr.map(p => p.email_unito)
          : [])
      ];
      return emails.find(e => typeof e === 'string' && e.trim() && e.trim() !== '-') || 'Non disponibile';
    },

    getPecValida(dettaglioContatto) {
      const pecs = [
        dettaglioContatto?.contatto?.pec,
        dettaglioContatto?.clienti?.[0]?.pec,
        Array.isArray(dettaglioContatto?.pods_summary?.pods)
          ? dettaglioContatto.pods_summary.pods.find(p => p.pec_unito)?.pec_unito
          : null,
        Array.isArray(dettaglioContatto?.pods_summary?.pdr)
          ? dettaglioContatto.pods_summary.pdr.find(p => p.pec_unito)?.pec_unito
          : null
      ];
      return pecs.find(e => e && e !== '-') || 'Non disponibile';
    },
    getTicketTypeClass(tipo) {
      const classes = {
        'Recupero': 'type-recupero',
        'Sollecito': 'type-sollecito',
        'Dilazione': 'type-dilazione'
      };
      return classes[tipo] || 'type-default';
    },
    getStatusClass(stato) {
      const classes = {
        'In Corso': 'status-in-corso',
        'Inviato': 'status-inviato',
        'Approvato': 'status-approvato'
      };
      return classes[stato] || 'status-default';
    },
    getStatoFatturaClass(stato) {
      const classes = {
        'Scaduta': 'stato-scaduta',
        'In Scadenza': 'stato-in-scadenza',
        'Attiva': 'stato-attiva',
        'Morosità': 'stato-morosita',
        'Sospesa': 'stato-sospesa'
      };
      return classes[stato] || 'stato-default';
    },
    handleSearch() {
      this.currentPageTickets = 1;
      this.currentPageFatture = 1;
    },
    clearSearch() {
      this.searchQuery = '';
      this.currentPageTickets = 1;
      this.currentPageFatture = 1;
    },
    viewTicket(ticket) {
      this.selectedTicket = { ...ticket };
      this.showTicketModal = true;
    },
    
    closeModal() {
      this.showTicketModal = false;
      this.showAddTicketModal = false;
      this.selectedTicket = {};
    },
    previousPageTickets() {
      if (this.currentPageTickets > 1) {
        this.currentPageTickets--;
      }
    },
    nextPageTickets() {
      if (this.currentPageTickets < this.totalPagesTickets) {
        this.currentPageTickets++;
      }
    },
    previousPageFatture() {
      if (this.currentPageFatture > 1) {
        this.currentPageFatture--;
      }
    },
    nextPageFatture() {
      if (this.currentPageFatture < this.totalPagesFatture) {
        this.currentPageFatture++;
      }
    },
    handleDilaziona() {
      this.openPodPdrSelectionModal('Dilaziona', { note: 'Dilazione richiesta' });
    },
    handleRimanda() {
      this.currentAction = 'Rimanda';
      this.rimandaData = { note: '', dataRimando: '', selectedPodPdr: null };
      this.showRimandaModal = true;
    },
    async handleDistacca() {
      try {
        if (this.selectedSection === 'cliente' && this.currentCredito) {
          let distaccaPermesso = true;

          const codPods = Array.from(
            new Set(
              (this.fattureTabella || [])
                .filter(f => f.cod_pod && f.cod_pod > 0)
                .map(f => f.cod_pod)
            )
          );
          const codPdrs = Array.from(
            new Set(
              (this.fattureTabella || [])
                .filter(f => f.cod_pdr && f.cod_pdr > 0)
                .map(f => f.cod_pdr)
            )
          );

          const params = {};
          if (codPods.length > 0) {
            params.cod_pod = codPods;
          }
          if (codPdrs.length > 0) {
            params.cod_pdr = codPdrs;
          }

          if (params.cod_pod || params.cod_pdr) {
            const check = await this.service.checkDistacco(params);

            let hasAnyTrue = false;
            if (check && check.success && check.distacco) {
              const podMap = check.distacco.pod || {};
              const pdrMap = check.distacco.pdr || {};
              hasAnyTrue =
                Object.values(podMap).some(Boolean) ||
                Object.values(pdrMap).some(Boolean);
            }

            if (!hasAnyTrue) {
              distaccaPermesso = false;
              this.$toast.add({
                severity: 'warn',
                summary: 'Attenzione',
                detail: 'Il distacco non è permesso in base alle regole di preavviso/saldo',
                life: 5000
              });
            } else {
              const volturaInfo = await this.service.getInfoClienteVoltura(params);

              if (volturaInfo && volturaInfo.success && volturaInfo.cliente) {
                const clienteVolturaId = volturaInfo.cliente.id;
                const clienteCorrenteId = this.currentCredito.cliente_id;

                if (clienteVolturaId !== clienteCorrenteId) {
                  distaccaPermesso = false;
                  this.$toast.add({
                    severity: 'warn',
                    summary: 'Attenzione',
                    detail: 'Il distacco non è permesso: il cliente della voltura non corrisponde al cliente corrente',
                    life: 5000
                  });
                } else {
                  console.log('Distacco permesso: cliente voltura corrisponde al cliente corrente');
                }
              }
            }
          }

          this.isDistaccaAllowed = distaccaPermesso;

          if (!distaccaPermesso) {
            return;
          }
        }

        this.openPodPdrSelectionModal('Distacca', { note: '' });
      } catch (error) {
        console.error('Errore nella gestione distacco:', error);
        this.isDistaccaAllowed = false;
      }
    },
    closeRimandaModal() {
      this.showRimandaModal = false;
      this.rimandaData = { note: '', dataRimando: '', selectedPodPdr: null };
    },
    confermaRimanda() {
      const data = {
        note: this.rimandaData.note,
        dataRimando: this.rimandaData.dataRimando
      };
      
      const clienteData = this.currentCredito;
      const selectedSection = this.selectedSection;
      const selectedPodPdr = this.rimandaData.selectedPodPdr;
      
      
      this.handleRimando(data, clienteData, selectedSection, selectedPodPdr);
      this.closeRimandaModal();
      this.selectedSection = null;
      this.currentCredito = null;
      this.fattureTabella = [];
      this.dettaglioContatto = null;
      this.clientData = null;
      this.ticketsData = [];
    },
      closeDistaccaModal() {
        this.showDistaccaModal = false;
        this.distaccaData = { note: '', selectedPodPdr: null };
      },
      closeConfermaDilazioneModal() {
        this.showConfermaDilazioneModal = false;
        this.dataRimandaConferma = null;
        this.selectedPodPdrForDilazione = null;
        this.isLastPointForDilazione = false;
      },
      confermaDilazioneFinale() {
        const dataPrimaRataPiuVicina = this.dataRimandaConferma;
        
        const data = { 
          note: this.dilazioneData.note || 'Dilazione richiesta',
          ...(dataPrimaRataPiuVicina && { data_rimanda: dataPrimaRataPiuVicina })
        };
          
        const clienteData = this.currentCredito;
        const selectedSectionParam = this.selectedSection;
        const selectedPodPdr = this.selectedPodPdrForDilazione;

        if (Array.isArray(selectedPodPdr)) {
          const allSelected = this.isLastPointForDilazione === true;
          (async () => {
            for (let i = 0; i < selectedPodPdr.length; i++) {
              const punto = selectedPodPdr[i];
              const isLast = i === selectedPodPdr.length - 1;
              const payload = allSelected && isLast ? { ...data, completato: 1 } : { ...data };
              await this.handleDilazione(payload, clienteData, selectedSectionParam, punto);
            }
            this.$toast.add({
              severity: 'success',
              summary: 'Successo',
              detail: 'Dilazione creata con successo',
              life: 3000
            });
          })();
        } else {
          this.handleDilazione({ ...data, ...(this.isLastPointForDilazione && { completato: 1 }) }, clienteData, selectedSectionParam, selectedPodPdr);
        }
        this.closeConfermaDilazioneModal();
        this.resetToInitialView();
        
        this.$toast.add({
          severity: 'success',
          summary: 'Successo',
          detail: 'Dilazione creata con successo',
          life: 3000
        });
      },
      formatDateForDisplay(dateString) {
        if (!dateString) return 'N/A';
        
        const cleanDateString = dateString.toString().trim();
        
        try {
          const date = new Date(cleanDateString);
            if (isNaN(date.getTime())) {
            console.warn('Data non valida:', dateString);
            return cleanDateString; 
          }
          
          return date.toLocaleDateString('it-IT', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          });
        } catch (error) {
          console.warn('Errore nel formattare la data:', dateString, error);
          return cleanDateString; 
        }
      },
    async confermaDistacca() {
      try {
        const selectedPodPdr = this.distaccaData.selectedPodPdr;
        if (selectedPodPdr) {
          const params = {};
          if (selectedPodPdr.cod_pod) {
            params.cod_pod = selectedPodPdr.cod_pod;
          }
          if (selectedPodPdr.cod_pdr) {
            params.cod_pdr = selectedPodPdr.cod_pdr;
          }
          
          if (params.cod_pod || params.cod_pdr) {
            const volturaInfo = await this.service.getInfoClienteVoltura(params);
            console.log('Risposta getInfoClienteVoltura:', volturaInfo);
          }
        }
      } catch (error) {
        console.error('Errore nella chiamata getInfoClienteVoltura:', error);
      }
      
      const puntiNonGestiti = this.availablePods.filter(pod => !pod.esito_gestione).length + this.availablePdrs.filter(pdr => !pdr.esito_gestione).length;
      const isLastPoint = puntiNonGestiti === 1;
      
      const data = {
        note: this.distaccaData.note,
        ...(isLastPoint && { completato: 1 })
      };
      
      const clienteData = this.currentCredito;
      const selectedSection = this.selectedSection;
      const selectedPodPdr = this.distaccaData.selectedPodPdr;
      
      
      this.handleDistacco(data, clienteData, selectedSection, selectedPodPdr);
      this.closeDistaccaModal();
      this.selectedSection = null;
      this.currentCredito = null;
      this.fattureTabella = [];
      this.dettaglioContatto = null;
      this.clientData = null;
      this.ticketsData = [];
    },
    
    getSortedFatture() {
      const sorted = [...this.fattureTabella].sort((a, b) => {
        const aGroup = Number(a.saldo_fattura) > 0 ? 0 : 1;
        const bGroup = Number(b.saldo_fattura) > 0 ? 0 : 1;
        if (aGroup !== bGroup) return aGroup - bGroup;

        if (!this.sortKey) return 0;

        let valA = a[this.sortKey];
        let valB = b[this.sortKey];
        if (this.sortKey === 'saldo_fattura') {
          valA = Number(valA);
          valB = Number(valB);
        }
        if (this.sortKey === 'data_emissione' || this.sortKey === 'data_scadenza_fattura') {
          valA = new Date(valA);
          valB = new Date(valB);
        }
        if (valA == null) return 1;
        if (valB == null) return -1;
        if (valA === valB) return 0;
        return this.sortAsc ? (valA > valB ? 1 : -1) : (valA < valB ? 1 : -1);
      });
      return sorted;
    },
    
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortKey = key;
        this.sortAsc = true;
      }
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');

* {
    font-family: 'Montserrat', sans-serif !important;
    box-sizing: border-box;
}
.recupero-pagamento-dashboard {
  padding: 20px;
  background-color: #f8f9fa;
  min-height: 100vh;
}

.user-header {
  background: linear-gradient(90deg, #0d3c61 0%, #3388b3 100%);

  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.header-top-row {
  background: linear-gradient(90deg, #0d3c61 0%, #3388b3 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.header-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.next-credito-btn {
  background: linear-gradient(135deg, #3388b3, #0d3c61);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 180px;
  justify-content: center;
}

.next-credito-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #0d3c61, #1a5490);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(51, 136, 179, 0.3);
}

.next-credito-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

.next-credito-btn i {
  font-size: 1rem;
  font-weight: 900;
}

.pi-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.search-container {
  flex: 1;
  max-width: 400px;
}

.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #6c757d;
  z-index: 1;
}

.search-input {
  width: 100%;
  padding: 10px 40px 10px 40px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.3s;
}

.search-input:focus {
  outline: none;
  border-color: #007bff;
}

.clear-search {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  padding: 4px;
}

.user-name-container {
  flex: 1;
  text-align: center;
}

.name-and-button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.incall-navigation-btn {
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-left: 6rem;
}

.incall-navigation-btn:hover {
  background: linear-gradient(135deg, #218838, #1ea085);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.incall-navigation-btn:active {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.incall-navigation-btn i {
  font-size: 0.875rem;
}

.dashboard-title {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  color: #ffffff;
}

.dashboard-subtitle {
  margin: 10;
  font-size: 30px;
  font-weight: 500;
  color: #ffffff;
}

.importo-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 150px;
}

.importo-label {
  font-size: 14px;
  color: #6c757d;
  margin-bottom: 4px;
}

.importo-value {
  font-size: 20px;
  font-weight: bold;
  color: #28a745;
}

.main-content {
  display: grid;
  grid-template-columns: 350px 1fr;
  gap: 24px;
  margin-bottom: 24px;
}

.user-details-card {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(13, 60, 97, 0.1);
  overflow: hidden;
  border: 1px solid rgba(13, 60, 97, 0.1);
  height: fit-content;
}


.info-card-header {
    background: linear-gradient(135deg, #0d3c61, #1a5490); 
    color: white;
    padding: 1rem 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
}

.toggle-icon {
  color: #007bff;
  font-size: 18px;
}

.info-card-content {
  padding: 20px;
}
.info-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0.75rem 0;
    border-bottom: 1px solid #e8eef5;
    gap: 1rem;
    margin-bottom: 0;
}

.info-row:last-child {
    border-bottom: none;
}

.info-label {
    font-weight: 600;
    color: #0d3c61;
    min-width: 10px;
    flex-shrink: 0;
}

.info-value {
    font-weight: 500;
    color: #2c5282;
    text-align: right;
    flex: 1;
    word-break: break-word;
}


.tickets-table-container,
.ft-insolute-container,
.dilazioni-table-container,
.notes-table-container {
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(13, 60, 97, 0.1);
    overflow: hidden;
    border: 1px solid rgba(13, 60, 97, 0.1);
    margin-bottom: 2rem;
}

.fatture-table-header {
    background: linear-gradient(135deg, #0d3c61, #1a5490);
    color: white;
    padding: 1rem 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.table-actions {
    display: flex;
    gap: 0.5rem;
}

.add-ticket-btn {
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: white;
    padding: 0.6rem 1.2rem;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.6rem;
    transition: all 0.2s ease;
}

.add-ticket-btn:hover {
    background: rgba(255, 255, 255, 0.3);
}

.add-icon {
    font-size: 1.2rem !important;
    font-weight: 900 !important;
    color: white !important;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

.fatture-table-wrapper {
    overflow-x: auto;
    max-width: 100%;
    max-height: 58vh; 
    overflow-y: auto;
}

.fatture-table {
  
    width: 100%;
    border-collapse: collapse;
    font-size: 0.85rem;
}

.fatture-table thead {
    background: linear-gradient(135deg, #e1edf7, #d1e3f4);
}

.fatture-table th {
    padding: 1rem 0.75rem;
    text-align: left;
    font-weight: 600;
    color: #0d3c61;
    border-bottom: 2px solid #c5d3e4;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;
}

.fatture-table td {
    padding: 0.75rem;
    text-align: left;
    border-bottom: 1px solid #e8eef5;
    color: #374151;
    font-weight: 500;
    white-space: nowrap;
}

.fatture-table tbody tr:nth-child(even) {
    background-color: #f8fafc;
}

.fatture-table tbody tr:hover {
    background-color: #e8f4fd;
    transition: background-color 0.2s ease;
}


.row-nonpositive {
    background-color: #e8f9e9 !important;
}

.row-sospendibile {
    background-color: #ffe4b5 !important; 
}

.sospendibile-legend {
    font-size: 1rem;
    font-weight: 700;
    margin-left: 4rem;
    opacity: 0.9;
}

.legend-square {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 3px;
    background-color: #ffe4b5; 
    border: 1px solid #f59e0b;
    margin-right: 1px;
    margin-bottom: 2.1px;
    vertical-align: middle;
}

.text-center {
    text-align: center !important;
}

.ticket-type {
    padding: 0.25rem 0.75rem;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.type-recupero {
    background: #fef2f2;
    color: #dc2626;
}

.type-sollecito {
    background: #fef3c7;
    color: #d97706;
}

.type-dilazione {
    background: #e8f5e8;
    color: #2d5016;
}

.status-badge {
    padding: 0.25rem 0.75rem;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.status-in-corso {
    background: #fef3c7;
    color: #92400e;
}

.status-inviato {
    background: #dbeafe;
    color: #1e40af;
}

.status-approvato {
    background: #d1fae5;
    color: #065f46;
}

.status-dot {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    vertical-align: middle;
    transition: all 0.2s ease;
    margin-right: 0.5rem;
}

.status-dot:hover {
    transform: scale(1.3);
}

.stato-scaduta {
    background-color: #dc2626;
    box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.2);
    border: 2px solid #ffffff;
}

.stato-in-scadenza {
    background-color: #f59e0b;
    box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.2);
    border: 2px solid #ffffff;
}

.stato-attiva {
    background-color: #10b981;
    box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.2);
    border: 2px solid #ffffff;
}

.stato-morosita {
    background-color: #8b5cf6;
    box-shadow: 0 0 0 4px rgba(139, 92, 246, 0.2);
    border: 2px solid #ffffff;
}

.stato-sospesa {
    background-color: #6b7280;
    box-shadow: 0 0 0 4px rgba(107, 114, 128, 0.2);
    border: 2px solid #ffffff;
}

.cmor-green {
    background-color: #10b981;
    box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.2);
    border: 2px solid #ffffff;
}

.cmor-red {
    background-color: #dc2626;
    box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.2);
    border: 2px solid #ffffff;
}

.status-text {
    font-weight: 600;
    color: #374151;
}

.importo-cell {
    font-weight: 700;
    color: #0d3c61;
    text-align: right !important;
}
.fattura-actions {
    display: flex;
    gap: 0.5rem;
    justify-content: center;
}

.action-btn {
    background: white;
    border: 2px solid;
    padding: 0.5rem;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1rem;
    font-weight: bold;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.view-btn {
    border-color: #6c757d;
    color: #6c757d;
}

.view-btn:hover {
    background: #6c757d;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}

.edit-btn {
    border-color: #3388b3;
    color: #3388b3;
}

.edit-btn:hover {
    background: #3388b3;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(51, 136, 179, 0.3);
}

.table-icon {
    font-size: 1.1rem !important;
    font-weight: 900 !important;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
}


.no-data-message {
    text-align: center;
    padding: 2rem;
    color: #64748b;
    font-style: italic;
    background: linear-gradient(135deg, #f8fafc, #ffffff);
    border-radius: 8px;
    margin: 1rem;
    
}

.no-data-message::before {
    content: '📋';
    display: block;
    font-size: 2rem;
    margin-bottom: 0.5rem;
}

.error-message {
    background: linear-gradient(135deg, #fef2f2, #fee2e2);
    border: 1px solid #fecaca;
    color: #dc2626;
    padding: 1rem 1.5rem;
    border-radius: 8px;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(220, 38, 38, 0.1);
}

.error-message i {
    font-size: 1.2rem;
    color: #dc2626;
}

.pagination-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1.5rem;
    background: #f8fafc;
    border-top: 1px solid #e8eef5;
}

.pagination-info {
    font-size: 0.85rem;
    color: #64748b;
    font-weight: 500;
}

.pagination-controls {
    display: flex;
    gap: 0.5rem;
    align-items: center;
}

.pagination-btn {
    background: white;
    border: 1px solid #d1d5db;
    color: #374151;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-weight: 500;
    min-width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pagination-btn:hover:not(:disabled) {
    background: #f3f4f6;
    border-color: #9ca3af;
    transform: translateY(-1px);
}

.pagination-btn:disabled {
    background: #f9fafb;
    color: #d1d5db;
    cursor: not-allowed;
    border-color: #e5e7eb;
}

.pagination-icon {
    font-size: 1rem !important;
    font-weight: 900 !important;
}

.page-indicator {
    padding: 0.5rem 1rem;
    font-weight: 600;
    color: #0d3c61;
    background: white;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    min-width: 80px;
    text-align: center;
}


.main-action-buttons {
    display: flex;
    justify-content: center;
    gap: 2rem;
    margin-top: 2rem;
    padding: 2rem;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(13, 60, 97, 0.1);
    border: 1px solid rgba(13, 60, 97, 0.1);
}

.main-action-btn {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1.5rem 3rem;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    font-weight: 700;
    font-size: 1.1rem;
    letter-spacing: 0.5px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    min-width: 200px;
    justify-content: center;
    text-transform: uppercase;
    border: 2px solid rgba(255, 255, 255, 0.2);
}

.main-icon {
    font-size: 2rem !important;
    font-weight: 900 !important;
    color: white !important;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

.main-action-btn span {
    font-size: 1rem;
    font-weight: 700;
    color: white;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

.main-action-btn.dilaziona-btn {
    background: linear-gradient(135deg, #10b981, #059669);
    color: white;
}

.main-action-btn.dilaziona-btn:hover {
    background: linear-gradient(135deg, #059669, #047857);
    transform: translateY(-4px);
    box-shadow: 0 12px 35px rgba(16, 185, 129, 0.5);
    border-color: rgba(255, 255, 255, 0.4);
}

.main-action-btn.rimanda-btn {
    background: linear-gradient(135deg, #f59e0b, #d97706);
    color: white;
}

.main-action-btn.rimanda-btn:hover {
    background: linear-gradient(135deg, #d97706, #b45309);
    transform: translateY(-4px);
    box-shadow: 0 12px 35px rgba(245, 158, 11, 0.5);
    border-color: rgba(255, 255, 255, 0.4);
}

.main-action-btn.distacca-btn {
    background: linear-gradient(135deg, #ef4444, #dc2626);
    color: white;
}

.main-action-btn.distacca-btn:hover:not(:disabled) {
    background: linear-gradient(135deg, #dc2626, #b91c1c);
    transform: translateY(-4px);
    box-shadow: 0 12px 35px rgba(239, 68, 68, 0.5);
    border-color: rgba(255, 255, 255, 0.4);
}

.main-action-btn.distacca-btn:disabled,
.main-action-btn.distacca-btn.disabled {
    background: linear-gradient(135deg, #9ca3af, #6b7280) !important;
    color: #d1d5db !important;
    cursor: not-allowed !important;
    transform: none !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    border-color: rgba(255, 255, 255, 0.1) !important;
    opacity: 0.6;
}

.main-action-btn.distacca-btn:disabled span,
.main-action-btn.distacca-btn.disabled span {
    color: #d1d5db !important;
    text-shadow: none !important;
}

.main-action-btn.tutela-btn {
    background: linear-gradient(135deg, #6366f1, #3b82f6);
    color: white;
}

.main-action-btn.tutela-btn:hover {
    background: linear-gradient(135deg, #3b82f6, #1e40af);
    transform: translateY(-4px);
    box-shadow: 0 12px 35px rgba(99, 102, 241, 0.5);
    border-color: rgba(255, 255, 255, 0.4);
}


.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(4px);
}

.modal-content {
    background: white;
    border-radius: 12px;
    width: 90%;
    max-width: 500px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    animation: modalAppear 0.3s ease-out;
}

@keyframes modalAppear {
    from {
        opacity: 0;
        transform: translateY(20px) scale(0.95);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

.modal-header {
    background: linear-gradient(135deg, #0d3c61, #1a5490);
    color: white;
    padding: 1rem 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
}

.modal-header-view {
    background: linear-gradient(135deg, #0d3c61, #1a5490);
}

.close-button {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    font-size: 1.2rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.close-button:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
}

.modal-body {
    padding: 1.5rem;
}

.ticket-details {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.detail-row {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 0;
    border-bottom: 1px solid #e8eef5;
}

.detail-row:last-child {
    border-bottom: none;
}

.modal-footer {
    padding: 1.5rem;
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    border-top: 1px solid #e5e7eb;
    background: #f8fafc;
}

.btn-secondary {
    background: #64748b;
    color: white;
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
    min-width: 100px;
}

.btn-secondary:hover {
    background: #475569;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(100, 116, 139, 0.3);
}


.form-group {
    margin-bottom: 1.5rem;
}

.form-group label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 600;
    color: #0d3c61;
    font-size: 0.9rem;
}

.form-label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
    font-weight: 600;
    color: #0d3c61;
    font-size: 0.9rem;
}

.form-label i {
    color: #3388b3;
    font-size: 1rem;
}

.link-entity-toggle {
    display: flex;
    gap: 0.5rem;
    align-items: center;
}

.entity-dropdown {
    margin-top: 0.5rem;
    background: #fff;
    border: 2px solid #e1edf7;
    border-radius: 8px;
    max-height: 200px;
    overflow-y: auto;
    box-shadow: 0 8px 20px rgba(13, 60, 97, 0.15);
}

.entity-item {
    padding: 0.5rem 0.75rem;
    cursor: pointer;
    border-bottom: 1px solid #e8eef5;
}

.entity-item:hover {
    background: #e8f4fd;
}

.form-textarea,
.form-input {
    width: 100%;
    padding: 0.75rem;
    border: 2px solid #e1edf7;
    border-radius: 8px;
    font-size: 0.9rem;
    font-family: inherit;
    transition: all 0.3s ease;
    background: white;
    font-weight: 500;
    resize: vertical;
}

.form-textarea:focus,
.form-input:focus {
    outline: none;
    border-color: #3388b3;
    box-shadow: 0 0 0 3px rgba(51, 136, 179, 0.1);
}

.form-help {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.75rem;
    color: #64748b;
    font-style: italic;
}

.btn-primary {
    background: linear-gradient(135deg, #3388b3, #0d3c61);
    color: white;
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
    min-width: 100px;
}

.btn-primary:hover:not(:disabled) {
    background: linear-gradient(135deg, #0d3c61, #1a5490);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(51, 136, 179, 0.3);
}

.btn-primary:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
    box-shadow: none !important;
}

.btn-success {
    background: linear-gradient(135deg, #10b981, #059669);
    color: white;
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
    min-width: 100px;
}

.btn-success:hover:not(:disabled) {
    background: linear-gradient(135deg, #059669, #047857);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(16, 185, 129, 0.3);
}

.btn-success:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
    box-shadow: none !important;
}

.dilazione-question {
    text-align: center;
    padding: 1rem;
}

.dilazione-question p {
    font-size: 1.1rem;
    color: #0d3c61;
    font-weight: 600;
    margin: 0;
}


.no-credito-message {
    background: linear-gradient(135deg, #f0f9ff, #e0f2fe);
    border: 1px solid #bae6fd;
    color: #0369a1;
    padding: 3rem 2rem;
    border-radius: 12px;
    margin: 2rem 0;
    text-align: center;
    box-shadow: 0 4px 20px rgba(3, 105, 161, 0.1);
}

.no-credito-message i {
    font-size: 3rem;
    color: #0ea5e9;
    margin-bottom: 1rem;
    display: block;
}

.no-credito-message h3 {
    margin: 0 0 1rem 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: #0c4a6e;
}

.no-credito-message p {
    margin: 0 0 2rem 0;
    font-size: 1.1rem;
    color: #0369a1;
    opacity: 0.9;
}

.refresh-btn {
    background: linear-gradient(135deg, #0ea5e9, #0284c7);
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
}

.refresh-btn:hover {
    background: linear-gradient(135deg, #0284c7, #0369a1);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(14, 165, 233, 0.3);
}

.refresh-btn i {
    font-size: 1rem;
    font-weight: 900;
}

.telefono-grande {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0d3c61;
  letter-spacing: 1px;
}

.dashboard-boxes-row {
  display: flex;
  gap: 1rem;
  margin: 1.5rem 0;
  justify-content: center;
  flex-wrap: wrap; 
}

.dashboard-box {
  min-width: 220px;
  max-width: 200px;
  flex: 1 1 180px;
  background: linear-gradient(135deg, #3388b3, #0d3c61);
  color: #fff;
  border-radius: 12px;
  padding: 2rem 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 2px 8px rgba(13, 60, 97, 0.10);
  font-size: 0.95rem;
}

.box-label {
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 0.3rem;
  color: #fff;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.box-value {
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
  word-break: break-all;
  text-align: center;
}

.clienti-saldo-container {
  margin: 2rem 0;
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.clienti-boxes {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  overflow-x: auto;
  padding-bottom: 0.5rem;
  scrollbar-width: thin;
  scrollbar-color: #ccc #f1f1f1;
  justify-content: center;
}

.clienti-boxes::-webkit-scrollbar {
  height: 8px;
}

.clienti-boxes::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.clienti-boxes::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.clienti-boxes::-webkit-scrollbar-thumb:hover {
  background: #999;
}

.cliente-box {
  background: linear-gradient(135deg, #28a745, #20c997);
  color: #fff;
  border-radius: 8px;
  padding: 1.25rem;
  box-shadow: 0 2px 6px rgba(40, 167, 69, 0.2);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
  min-width: 200px;
  max-width: 250px;
  flex-shrink: 0;
}

.cliente-box:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.cliente-nome {
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #fff;
  line-height: 1.3;
  word-break: break-word;
}

.cliente-saldo {
  font-size: 1.1rem;
  font-weight: 700;
  color: #fff;
  text-align: center;
  background: rgba(255, 255, 255, 0.15);
  padding: 0.5rem;
  border-radius: 6px;
  letter-spacing: 0.5px;
}

.no-clienti-message {
  text-align: center;
  padding: 2rem;
  color: #666;
  font-style: italic;
}

.cliccabile {
  cursor: pointer;
  color: #fff;
}

.fattura-cliccabile{
  cursor: pointer;
}

.pdp-cliccabile {
  cursor: pointer;
  color: #1a5490;
  font-weight: 700;
}

.section-selector {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin: 2rem 0 2.5rem 0;
}
.section-btn {
  background: #fff;
  color: #0d3c61;
  border: none;
  border-radius: 8px;
  padding: 1rem 5.5rem;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(13, 60, 97, 0.08);
}
.section-btn.active,
.section-btn:hover {
  background: linear-gradient(90deg, #3388b3 0%, #0d3c61 100%);
  color: #fff;
  transform: translateY(-2px) scale(1.04);
}

.card {
  background: linear-gradient(90deg, #0d3c61 0%, #3388b3 100%);
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(13, 60, 97, 0.08);
  padding: 2rem 2.5rem 1.5rem 2.5rem;
  margin-bottom: 2.5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.card-header h2 {
  color: #fff;
  font-size: 1.6rem;
  font-weight: 700;
  letter-spacing: 1px;
  text-align: center;
}

.card-body {
  display: flex;
  gap: 1.5rem;
  width: 100%;
  justify-content: center;
}

.totale-saldo-box {
  margin: 1.5rem 0 0.5rem 0;
  padding: 1rem 2rem;
  background: #e1edf7;
  border-radius: 10px;
  font-size: 1.1em;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.fatture-count-box {
  margin: 1.5rem 0 0.5rem 0;
  padding: 1rem 2rem;
  background: #e1edf7;
  border-radius: 10px;
  font-size: 1.1em;
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-content: center;
}
.fatture-count-label {
  font-weight: 600;
  color: #0d3c61;
}
.fatture-count-value {
  font-weight: 700;
  color: #3388b3;
  font-size: 1.3em;
}

.pod-box {
  background: linear-gradient(135deg, #fbbf24, #f59e0b); 
  color: #fff;
}
.insoluto-pod-box {
  background: linear-gradient(135deg, #fbbf24, #f59e0b); 
  color: #fff;
}
.pdr-box {
  background: linear-gradient(135deg, #10b981, #059669); 
  color: #fff;
}
.insoluto-pdr-box {
  background: linear-gradient(135deg, #10b981, #059669); 
  color: #fff;
}

.modal-content-large {
    max-width: 95%;
    width: 95%;
    max-height: 90vh;
    overflow-y: auto;
}

.pod-pdr-selection {
    max-height: 60vh;
    overflow-y: auto;
}

.selection-tabs {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1.5rem;
    border-bottom: 2px solid #e8eef5;
    padding-bottom: 1rem;
}

.tab-btn {
    background: #f8fafc;
    border: 2px solid #e8eef5;
    color: #64748b;
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.3s ease;
    min-width: 120px;
}

.tab-btn.active {
    background: linear-gradient(135deg, #3388b3, #0d3c61);
    color: white;
    border-color: #3388b3;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(51, 136, 179, 0.3);
}

.tab-btn:hover:not(.active) {
    background: #e8f4fd;
    border-color: #3388b3;
    color: #0d3c61;
}

.pod-pdr-list {
    display: grid;
    gap: 1rem;
    max-height: 50vh;
    overflow-y: auto;
}

.pod-pdr-item {
    background: white;
    border: 2px solid #e8eef5;
    border-radius: 12px;
    padding: 1.5rem;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(13, 60, 97, 0.08);
}

.pod-pdr-item.ech-point {
    background-color: #ffe4b5;
    border-color: #f59e0b;
}

.pod-pdr-item:hover {
    border-color: #3388b3;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(51, 136, 179, 0.15);
}

.pod-pdr-item.selected {
    border-color: #3388b3;
    background: linear-gradient(135deg, #f0f9ff, #e0f2fe);
    box-shadow: 0 8px 25px rgba(51, 136, 179, 0.2);
}

.pod-pdr-item.gestito {
    border-color: #f59e0b;
    background: linear-gradient(135deg, #fffbeb, #fef3c7);
    position: relative;
}

.pod-pdr-item.gestito::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-top: 20px solid #f59e0b;
}

.pod-pdr-item.gestito.selected {
    border-color: #3388b3;
    background: linear-gradient(135deg, #f0f9ff, #e0f2fe);
}

.item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid #e8eef5;
}

.item-code {
    font-size: 1.2rem;
    font-weight: 700;
    color: #0d3c61;
}

.item-type {
    background: linear-gradient(135deg, #3388b3, #0d3c61);
    color: white;
    padding: 0.25rem 0.75rem;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.gestione-status {
    padding: 0.25rem 0.75rem;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-left: 0.5rem;
}

.gestione-status.distacca {
    background: linear-gradient(135deg, #ef4444, #dc2626);
    color: white;
}

.gestione-status.rimanda {
    background: linear-gradient(135deg, #f59e0b, #d97706);
    color: white;
}

.gestione-status.dilaziona {
    background: linear-gradient(135deg, #3b82f6, #2563eb);
    color: white;
}

.gestione-status.tutela {
    background: linear-gradient(135deg, #8b5cf6, #7c3aed);
    color: white;
}

.gestione-status.risolto {
    background: linear-gradient(135deg, #10b981, #059669);
    color: white;
}

.item-details {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.detail-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.25rem 0;
}

.detail-label {
    font-weight: 600;
    color: #64748b;
    font-size: 0.9rem;
}

.detail-value {
    font-weight: 500;
    color: #0d3c61;
    text-align: right;
    max-width: 60%;
    word-break: break-word;
}

.contestazione-value {
    color: #dc2626;
    font-weight: 800;
}

.single-point-summary {
  margin-bottom: 1rem;
  background: #fff;
  border: 2px solid #e8eef5;
  border-radius: 12px;
  padding: 1rem;
}

.single-point-summary-row + .single-point-summary-row {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid #e8eef5;
}

.single-point-summary-row.ech-point {
  background-color: #ffe4b5;
  border: 2px solid #f59e0b;
  border-radius: 8px;
  padding: 0.75rem;
  margin: 0 -0.25rem;
}

.single-point-summary-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.25rem;
  color: #0d3c61;
}

.single-point-summary-type {
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  background: #e8f4fd;
  color: #0d3c61;
}

.no-items {
    text-align: center;
    padding: 3rem 2rem;
    color: #64748b;
    background: #f8fafc;
    border-radius: 12px;
    border: 2px dashed #e8eef5;
}

.no-items i {
    font-size: 2rem;
    color: #94a3b8;
    margin-bottom: 1rem;
    display: block;
}

.no-items p {
    margin: 0;
    font-size: 1rem;
    font-weight: 500;
}


.stats-divider {
    height: 1px;
    background: linear-gradient(90deg, transparent, #e5e7eb, transparent);
    margin: 1rem 0;
}

.stats-header {
    margin-bottom: 0.5rem;
}

.stats-title {
    font-weight: 600;
    color: #374151;
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.stats-value {
    font-weight: 600;
    font-size: 0.95rem;
}

.saldo-positivo {
  color: #dc2626;
}

.saldo-negativo {
    color: #059669;
}

.saldo-zero {
    color: #6b7280;
}

.send-bonaria-btn {
  background: rgba(255, 152, 0, 0.2) !important;
  border: 1px solid rgba(255, 152, 0, 0.4) !important;
  color: white !important;
}

.send-bonaria-btn:hover {
  background: rgba(255, 152, 0, 0.4) !important;
  border: 1px solid rgba(255, 152, 0, 0.6) !important;
}

.fatture-selection-container {
  padding: 1rem;
}

.selection-info {
  margin-bottom: 1rem;
  color: #374151;
  font-size: 0.95rem;
}

.fatture-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-height: 400px;
  overflow-y: auto;
}

.fattura-item {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0.75rem;
  transition: all 0.2s ease;
}

.fattura-item:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.fattura-checkbox {
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  user-select: none;
}

.fattura-checkbox input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  flex-shrink: 0;
}

.fattura-info {
  flex: 1;
}

.fattura-numero {
  font-weight: 600;
  color: #0d3c61;
  margin-bottom: 0.25rem;
}

.fattura-details {
  display: flex;
  gap: 1rem;
  font-size: 0.85rem;
  color: #64748b;
}

.fattura-data {
  color: #64748b;
}

.fattura-importo {
  font-weight: 600;
  color: #0d3c61;
  margin-left: auto;
}

.modal-large {
  max-width: 600px;
  width: 90%;
}

</style>